import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom"; // v3.4.137 — ?req=<id>
import { useAuth } from "../context/AuthContext";
import { disbursements as disbApi, projects as projectsApi } from "../services/api";
import toast from "react-hot-toast";
// v3.4.372 — طريقة الصرف وتاريخه
const PAY_METHODS = { bank_transfer: "🏦 حوالة بنكية", cash: "💵 كاش" };
// v3.4.373 — أنواع الطلبات
const TYPE_BADGE = { dalala: "🟢 صرف دلالة", arboun: "🔵 إرجاع عربون", resale_refund: "↩️ إرجاع مبلغ إعادة بيع" };
const TYPE_TITLE = { dalala: "💰 طلب صرف دلالة", arboun: "💵 طلب إرجاع عربون", resale_refund: "↩️ طلب إرجاع مبلغ إعادة بيع" };
const fmtN0 = (n) => (Number(n) || 0).toLocaleString("en-US");
const payMethodLabel = (m) => PAY_METHODS[m] || "—";
const paidDateOf = (r) => (r.paid_at ? String(r.paid_at).slice(0, 10) : r.accountant_at ? new Date(r.accountant_at).toISOString().slice(0, 10) : null);
const todayISO = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
// نافذة التنفيذ / تعديل بيانات الصرف
function ExecuteModal({ target, onClose, onDone }) {
  const editMode = target.mode === "edit";
  const [method, setMethod] = useState(target.payment_method || "bank_transfer");
  const [date, setDate] = useState(target.paid_at || todayISO());
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      if (editMode) await disbApi.updatePayment(target.id, { payment_method: method, paid_at: date });
      else await disbApi.execute(target.id, { notes: notes.trim() || null, payment_method: method, paid_at: date });
      toast.success(editMode ? "حُدّثت بيانات الصرف" : "تم تأكيد الصرف بنجاح");
      onDone(true);
    } catch (err) { toast.error(err.response?.data?.error || "فشل"); setBusy(false); }
  };
  const btn = (bg, color, extra = {}) => ({ padding: "9px 16px", borderRadius: 8, border: "none", background: bg, color, fontWeight: 800, fontSize: 13, cursor: "pointer", fontFamily: "inherit", ...extra });
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={() => !busy && onDone(false)}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: 420, maxWidth: "100%", padding: 20 }}>
        <h3 style={{ margin: "0 0 4px", fontSize: 15 }}>{editMode ? "✎ تعديل بيانات الصرف" : "✅ تأكيد صرف الدلالة"} — طلب #{target.id}</h3>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 12 }}>{editMode ? "تاريخ الصرف الفعلي وطريقته" : "حدّد طريقة الصرف وتاريخه الفعلي — سيظهران في عمودَي «تاريخ الصرف» و«طريقة الصرف»"}</div>
        <div style={{ fontSize: 12, fontWeight: 800, color: "#334155", marginBottom: 6 }}>طريقة الصرف</div>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {Object.entries(PAY_METHODS).map(([k, l]) => <button key={k} type="button" onClick={() => setMethod(k)} style={btn(method === k ? "#0f766e" : "#f1f5f9", method === k ? "#fff" : "#334155", { flex: 1, border: "1.5px solid " + (method === k ? "#0f766e" : "#e2e8f0") })}>{l}</button>)}
        </div>
        <label style={{ fontSize: 12, fontWeight: 800, color: "#334155", display: "block", marginBottom: 12 }}>تاريخ الصرف<input type="date" value={date} onChange={e => setDate(e.target.value)} style={{ display: "block", width: "100%", marginTop: 4, padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }} /></label>
        {!editMode && <label style={{ fontSize: 12, fontWeight: 800, color: "#334155", display: "block", marginBottom: 12 }}>ملاحظة (اختياري)<input value={notes} onChange={e => setNotes(e.target.value)} placeholder="مثال: رقم الحوالة" style={{ display: "block", width: "100%", marginTop: 4, padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }} /></label>}
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" onClick={save} disabled={busy || !date} style={btn("#16a34a", "#fff", { flex: 1 })}>{busy ? "…" : editMode ? "💾 حفظ" : "✅ تأكيد الصرف"}</button>
          <button type="button" onClick={() => onDone(false)} disabled={busy} style={btn("#f1f5f9", "#334155")}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}
import { FiPlus, FiCheck, FiX, FiDollarSign, FiRefreshCw, FiSearch, FiFilter, FiTrash2, FiEye, FiUser, FiHome, FiCalendar, FiFileText, FiExternalLink } from "react-icons/fi";

// ══════════════════════════════════════════════════════════════
// صفحة صرف الدلالات وإرجاع العرابين
// ══════════════════════════════════════════════════════════════

const fmt = (n) => n ? Number(n).toLocaleString("en-SA") : "0";

const STATUS_LABELS = {
  pending_admin: "بانتظار الاعتماد",
  pending_accountant: "بانتظار التنفيذ",
  done: "تم",
  rejected: "مرفوض",
};

const STATUS_COLORS = {
  pending_admin: { bg: "#fef3c7", color: "#92400e" },
  pending_accountant: { bg: "#dbeafe", color: "#1e40af" },
  done: { bg: "#dcfce7", color: "#166534" },
  rejected: { bg: "#fee2e2", color: "#991b1b" },
};

function getRequestStatus(req) {
  if (req.admin_status === 'rejected') return 'rejected';
  if (req.accountant_status === 'done') return 'done';
  if (req.admin_status === 'approved') return 'pending_accountant';
  return 'pending_admin';
}

export default function DisbursementsPage() {
  const { user } = useAuth();
  const navigate = useNavigate(); // v3.3.555 — for navigating to unit pages from the table
  // في وضع المعاينة، لا نعتبره أدمن
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  const disbPerms = user?.module_perms?.disbursements || {};
  const canRequest = isAdmin || disbPerms.can_request;
  const canApprove = isAdmin || disbPerms.can_approve;
  const canExecute = isAdmin || disbPerms.can_execute;
  const canDelete = isAdmin || disbPerms.can_delete;

  const [requests, setRequests] = useState([]);
  // v3.4.137 — فتح طلب محدد مباشرة من بطاقة الحجز: /disbursements?req=<id>
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const rid = searchParams.get("req");
    if (!rid) return;
    disbApi.list({ id: rid }).then(r => {
      const found = (r.data.requests || [])[0];
      if (found) setSelectedRequest(found); else toast.error(`طلب الصرف #${rid} غير موجود`);
    }).catch(() => toast.error("تعذر فتح الطلب"));
    setSearchParams({}, { replace: true });
  }, []); // eslint-disable-line
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState({ request_type: "all", status: "pending_admin" }); // v3.4.575 — يفتح افتراضيًا على «بانتظار الاعتماد»
  const [showFilters, setShowFilters] = useState(false);
  const [showNewRequest, setShowNewRequest] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const searchTimer = useRef(null);
  const [selectedRequest, setSelectedRequest] = useState(null); // لعرض التفاصيل
  const [showArchived, setShowArchived] = useState(false); // عرض الأرشيف
  const [view, setView] = useState("list"); // v3.4.142 — list | due (الدلالات المستحقة)

  // ══════════════════════════════════════════════════════════════
  // جلب البيانات
  // ══════════════════════════════════════════════════════════════
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: 50, ...filters, archived: showArchived };
      const [reqRes, statsRes] = await Promise.all([
        disbApi.list(params),
        disbApi.stats()
      ]);
      setRequests(reqRes.data.requests || []);
      setPagination(reqRes.data.pagination || {});
      setStats(statsRes.data.stats || null);
    } catch (err) {
      console.error(err);
      toast.error("فشل في جلب البيانات");
    }
    setLoading(false);
  }, [page, filters, showArchived]);

  useEffect(() => { fetchData(); }, [fetchData]);

  // ══════════════════════════════════════════════════════════════
  // الإجراءات
  // ══════════════════════════════════════════════════════════════
  const handleApprove = async (id, status, notes = null) => {
    // إذا كان الرفض بدون ملاحظات من النافذة المنبثقة، اطلب من المستخدم
    if (status === 'rejected' && notes === null) {
      notes = window.prompt("سبب الرفض:");
      if (notes === null) return; // cancelled
    }
    try {
      await disbApi.approve(id, status, notes);
      toast.success(status === 'approved' ? "تم الاعتماد" : "تم الرفض");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || "فشل في تحديث الطلب");
    }
  };

  const [execTarget, setExecTarget] = useState(null); // v3.4.372 — { id, mode, payment_method, paid_at, resolve }
  const handleExecute = (id) => new Promise(resolve => setExecTarget({ id, mode: "execute", resolve })); // v3.4.372 — نافذة طريقة/تاريخ الصرف
  const openPaymentEdit = (req) => setExecTarget({ id: req.id, mode: "edit", payment_method: req.payment_method || "bank_transfer", paid_at: paidDateOf(req) || todayISO(), resolve: () => {} });
  const closeExec = (ok) => { const t = execTarget; setExecTarget(null); if (ok) fetchData(); t && t.resolve && t.resolve(ok); };

  const handleDelete = async (id) => {
    if (!window.confirm("حذف هذا الطلب؟")) return;
    try {
      await disbApi.delete(id);
      toast.success("تم الحذف");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || "فشل في الحذف");
    }
  };

  const handleArchive = async (id) => {
    if (!window.confirm("أرشفة هذا الطلب؟")) return;
    try {
      await disbApi.archive(id);
      toast.success("تم الأرشفة");
      setSelectedRequest(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || "فشل في الأرشفة");
    }
  };

  const handleUnarchive = async (id) => {
    if (!window.confirm("إلغاء أرشفة هذا الطلب؟")) return;
    try {
      await disbApi.unarchive(id);
      toast.success("تم إلغاء الأرشفة");
      setSelectedRequest(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || "فشل في إلغاء الأرشفة");
    }
  };

  // ══════════════════════════════════════════════════════════════
  // العرض
  // ══════════════════════════════════════════════════════════════
  return (
    <div className="main-page" dir="rtl">
      {/* الإحصائيات */}
      {stats && (
        <div className="stats-row">
          <div className="stat-card" style={{ borderTopColor: "#f59e0b" }}>
            <div className="stat-label">بانتظار الاعتماد</div>
            <div className="stat-val" style={{ color: "#f59e0b" }}>{stats.pending_admin || 0}</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#3b82f6" }}>
            <div className="stat-label">بانتظار التنفيذ</div>
            <div className="stat-val" style={{ color: "#3b82f6" }}>{stats.pending_accountant || 0}</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#22c55e" }}>
            <div className="stat-label">مكتمل</div>
            <div className="stat-val" style={{ color: "#22c55e" }}>{stats.completed || 0}</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#ef4444" }}>
            <div className="stat-label">مرفوض</div>
            <div className="stat-val" style={{ color: "#ef4444" }}>{stats.rejected || 0}</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#059669" }}>
            <div className="stat-label">إجمالي الدلالات المصروفة</div>
            <div className="stat-val" style={{ color: "#059669" }}>{fmt(stats.total_dalala_paid)} ر.س</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#7c3aed" }}>
            <div className="stat-label">إجمالي العرابين المرتجعة</div>
            <div className="stat-val" style={{ color: "#7c3aed" }}>{fmt(stats.total_arboun_returned)} ر.س</div>
          </div>
          <div className="stat-card" style={{ borderTopColor: "#b45309" }}>{/* v3.4.373 */}
            <div className="stat-label">إجمالي مبالغ إعادة البيع المرتجعة</div>
            <div className="stat-val" style={{ color: "#b45309" }}>{fmt(stats.total_resale_refunded)} ر.س</div>
          </div>
        </div>
      )}

      {/* شريط الأدوات */}
      {view === "list" && (
      <div className="toolbar">
        <div className="search-wrap">
          <FiSearch size={16} />
          <input
            placeholder="بحث..."
            value={searchInput}
            onChange={e => {
              setSearchInput(e.target.value);
              clearTimeout(searchTimer.current);
              searchTimer.current = setTimeout(() => setPage(1), 400);
            }}
          />
        </div>
        <button
          className={`btn-filter ${showFilters ? "on" : ""}`}
          onClick={() => setShowFilters(f => !f)}
        >
          <FiFilter size={14} /> فلترة
        </button>
        {canRequest && !showArchived && (
          <button className="btn-new" onClick={() => setShowNewRequest(true)}>
            <FiPlus size={16} /> طلب جديد
          </button>
        )}
        <button
          className={`btn-filter ${showArchived ? "on" : ""}`}
          onClick={() => { setShowArchived(a => !a); setPage(1); }}
          style={{ background: showArchived ? "#64748b" : "#f1f5f9", color: showArchived ? "#fff" : "#475569" }}
        >
          📦 {showArchived ? "الطلبات النشطة" : `الأرشيف ${stats?.archived ? `(${stats.archived})` : ""}`}
        </button>
        <button
          className="btn-filter"
          onClick={fetchData}
          style={{ marginRight: "auto" }}
        >
          <FiRefreshCw size={14} /> تحديث
        </button>
        <span className="count">{pagination.total || 0} طلب</span>
      </div>
      )}

      {/* v3.4.373 — التبويبات الرئيسية الأربعة — v3.4.700: تحت شريط البحث (بطلب المالك) */}
      <div style={{ display: "flex", gap: 6, padding: "8px 12px 0", flexWrap: "wrap" }}>
        {[["list", "📋 الطلبات القائمة", "#1e293b"], ["arboun", "🔵 إدارة العرابين", "#1d4ed8"], ["due", "💰 إدارة الدلالات", "#166534"], ["resale", "↩️ إدارة عمليات إعادة البيع", "#b45309"] /* v3.4.380 */].map(([k, l, c]) => (
          <button key={k} onClick={() => { setView(k); if (k === "list") setPage(1); }} style={{ padding: "9px 16px", borderRadius: 10, border: view === k ? `2px solid ${c}` : "1px solid #e2e8f0", background: view === k ? c : "#fff", color: view === k ? "#fff" : "#475569", fontWeight: view === k ? 900 : 700, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
        ))}
      </div>

      {/* v3.4.142 — تبويب الدلالات المستحقة */}
      {/* v3.4.172 — حاوية تمرير خاصة بالتبويب حتى لا يضغط صف الإحصائيات */}
      {view === "due" && <div style={{ flex: 1, minHeight: 0, overflow: "auto", padding: 12 }}><DueDalalaTab canRequest={canRequest} isAdmin={isAdmin} onRequested={fetchData} /></div>}
      {view === "arboun" && <div style={{ flex: 1, minHeight: 0, overflow: "auto", padding: 12 }}><ArbounDueTab canRequest={canRequest} onRequested={fetchData} /></div>}{/* v3.4.373 */}
      {view === "resale" && <div style={{ flex: 1, minHeight: 0, overflow: "auto", padding: 12 }}><ResaleCyclesTab canRequest={canRequest} isAdmin={isAdmin} onRequested={fetchData} /></div>}
      {view === "list" && (<>
      {/* v3.4.381 — فلاتر بأزرار: نوع الطلب + حالة الطلب */}
      {(() => {
        const pill = (on, color) => ({ padding: "6px 14px", borderRadius: 999, border: `1.5px solid ${on ? color : "#e2e8f0"}`, background: on ? color : "#fff", color: on ? "#fff" : "#475569", fontWeight: on ? 800 : 600, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", display: "inline-flex", gap: 6, alignItems: "center", whiteSpace: "nowrap" });
        const cnt = (n) => (n === undefined || n === null ? null : <span style={{ fontSize: 10.5, background: "rgba(0,0,0,.08)", borderRadius: 999, padding: "0 6px" }}>{n}</span>);
        const types = [["all", "الكل", "#1e293b"], ["dalala", "🟢 صرف دلالة", "#16a34a"], ["arboun", "🔵 إرجاع عربون", "#2563eb"], ["resale_refund", "↩️ إرجاع مبلغ إعادة بيع", "#b45309"]];
        const statuses = [["all", "الكل", "#1e293b"], ["pending_admin", "⏳ بانتظار الاعتماد", "#f59e0b"], ["pending_accountant", "🕒 بانتظار التنفيذ", "#3b82f6"], ["done", "✅ مكتمل", "#22c55e"], ["rejected", "❌ مرفوض", "#ef4444"]];
        const stCount = { pending_admin: stats?.pending_admin, pending_accountant: stats?.pending_accountant, done: stats?.completed, rejected: stats?.rejected };
        return (
          <div style={{ padding: "6px 12px 0", display: "grid", gap: 6 }}>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
              <span style={{ fontSize: 11.5, color: "#64748b", fontWeight: 700, minWidth: 70 }}>نوع الطلب:</span>
              {types.map(([k, l, c]) => <button key={k} onClick={() => { setFilters(fl => ({ ...fl, request_type: k })); setPage(1); }} style={pill(filters.request_type === k, c)}>{l}</button>)}
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
              <span style={{ fontSize: 11.5, color: "#64748b", fontWeight: 700, minWidth: 70 }}>حالة الطلب:</span>
              {statuses.map(([k, l, c]) => <button key={k} onClick={() => { setFilters(fl => ({ ...fl, status: k })); setPage(1); }} style={pill(filters.status === k, c)}>{l}{!showArchived && cnt(stCount[k])}</button>)}
              {(filters.request_type !== "all" || filters.status !== "pending_admin") && <button onClick={() => { setFilters({ request_type: "all", status: "pending_admin" }); setPage(1); }} style={{ ...pill(false, "#64748b"), color: "#b91c1c", borderColor: "#fecaca" }}>✕ مسح الفلاتر</button>}
            </div>
          </div>
        );
      })()}
      {/* الفلاتر */}
      {showFilters && (
        <div className="filter-bar">
          <select
            value={filters.request_type}
            onChange={e => { setFilters(f => ({ ...f, request_type: e.target.value })); setPage(1); }}
          >
            <option value="all">كل الأنواع</option>
            <option value="dalala">صرف دلالة</option>
            <option value="arboun">إرجاع عربون</option>
            <option value="resale_refund">إرجاع مبلغ إعادة بيع</option>{/* v3.4.373 */}
          </select>
          <select
            value={filters.status}
            onChange={e => { setFilters(f => ({ ...f, status: e.target.value })); setPage(1); }}
          >
            <option value="all">كل الحالات</option>
            <option value="pending_admin">بانتظار الاعتماد</option>
            <option value="pending_accountant">بانتظار التنفيذ</option>
            <option value="done">مكتمل</option>
            <option value="rejected">مرفوض</option>
          </select>
          <button
            className="btn-clear"
            onClick={() => setFilters({ request_type: "all", status: "all" })}
          >
            مسح الفلاتر
          </button>
        </div>
      )}

      {/* الجدول */}
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>#</th>
              {/* v3.3.555 — Column now shows reservation_id (matches the /reservations page),
                  not serial_number. The previous serial_number is a separate internal field. */}
              <th>رقم الحجز</th>
              {/* v3.3.555 — New column: linked unit label (e.g., "A1-3"). Clickable. */}
              <th>رمز الوحدة</th>
              <th>العميل</th>
              <th>المطور</th>
              {/* v3.3.551 — Marketer column */}
              <th>اسم المسوّق</th>
              <th>النوع</th>
              <th>المبلغ</th>
              <th>طلب المدير</th>
              <th>اعتماد الأدمن</th>
              <th>تنفيذ المحاسب</th>
              <th>تاريخ الصرف</th>{/* v3.4.372 */}
              <th>طريقة الصرف</th>
              <th>الحالة</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={15} className="empty">جاري التحميل...</td></tr>
            ) : requests.length === 0 ? (
              <tr><td colSpan={15} className="empty">لا توجد طلبات</td></tr>
            ) : (
              requests.map(req => {
                const status = getRequestStatus(req);
                const statusStyle = STATUS_COLORS[status] || {};
                // v3.3.551 — Prefer structured marketer names (junction), fall back to legacy free-text
                const marketerDisplay = req.marketer_names || req.legacy_marketer_name || "—";
                // v3.3.555 — Linked unit info (from the disbursements GET query)
                const linkedUnit = req.linked_unit;
                return (
                  <tr key={req.id} onClick={() => setSelectedRequest(req)} style={{ cursor: "pointer" }}>
                    <td className="mono">{req.id}</td>
                    {/* v3.3.562 — Reservation number is now a clickable link that opens the reservation
                        in the main reservations page. Uses internal id (serial_number is hidden everywhere). */}
                    <td className="mono bold">
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          // Navigate to reservations page with the reservation id as a query param
                          // so it auto-opens the side panel
                          window.location.href = `/?reservation=${req.reservation_id}`;
                        }}
                        style={{
                          color: "#2563eb",
                          background: "#eff6ff",
                          padding: "2px 8px",
                          borderRadius: 4,
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        title={`فتح الحجز #${req.reservation_id}`}
                      >
                        #{req.reservation_id} ↗
                      </span>
                    </td>
                    {/* v3.3.555 — Unit code/label column. Click navigates to unit page. */}
                    <td onClick={(e) => {
                      if (!linkedUnit?.unit_id || !linkedUnit?.project_id) return;
                      e.stopPropagation();
                      navigate(`/projects/${linkedUnit.project_id}/units/${linkedUnit.unit_id}`);
                    }} style={{
                      fontSize: 12, fontWeight: 600,
                      color: linkedUnit?.unit_label ? "#0891b2" : "#cbd5e1",
                      cursor: linkedUnit?.unit_id && linkedUnit?.project_id ? "pointer" : "default",
                      textDecoration: linkedUnit?.unit_id && linkedUnit?.project_id ? "underline" : "none",
                    }} title={linkedUnit?.unit_id && linkedUnit?.project_id ? "اضغط لفتح صفحة الوحدة" : ""}>
                      {linkedUnit?.unit_label || (linkedUnit?.unit_id ? `وحدة #${linkedUnit.unit_id}` : "—")}
                    </td>
                    <td>{req.client_name}</td>
                    <td>{req.developer}</td>
                    <td style={{ fontSize: 12, color: marketerDisplay === "—" ? "#cbd5e1" : "#0f172a", fontWeight: marketerDisplay === "—" ? 400 : 600 }}>
                      {marketerDisplay}
                    </td>
                    <td>
                      <span style={{
                        background: req.request_type === 'dalala' ? "#dcfce7" : "#dbeafe",
                        color: req.request_type === 'dalala' ? "#166534" : "#1e40af",
                        padding: "2px 8px",
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 600
                      }}>
                        {TYPE_BADGE[req.request_type] || req.request_type}{/* v3.4.373 */}
                      </span>
                      {req.paid_externally && <div style={{ marginTop: 3 }}><span title="صُرفت خارج النظام سابقًا — تحتاج تأكيد المحاسب فقط" style={{ fontSize: 10, fontWeight: 800, padding: "1px 7px", borderRadius: 10, background: "#eff6ff", color: "#1e40af", border: "1px solid #bfdbfe", whiteSpace: "nowrap" }}>💸 صُرف سابقًا</span></div>}{/* v3.4.217 */}
                    </td>
                    <td className="money bold">{fmt(req.amount)} ر.س</td>
                    <td>
                      <div style={{ fontSize: 12 }}>
                        <span style={{ color: "#22c55e" }}>✓</span> {req.requested_by_name || "—"}
                      </div>
                      <div style={{ fontSize: 10, color: "#94a3b8" }}>
                        {req.requested_at ? new Date(req.requested_at).toLocaleDateString("ar-SA") : ""}
                      </div>
                    </td>
                    <td>
                      {req.admin_status === 'pending' ? (
                        <span style={{ color: "#f59e0b" }}>⏳ بانتظار</span>
                      ) : req.admin_status === 'approved' ? (
                        <div>
                          <span style={{ color: "#22c55e" }}>✅ معتمد</span>
                          <div style={{ fontSize: 10, color: "#94a3b8" }}>{req.admin_by_name}</div>
                        </div>
                      ) : (
                        <div>
                          <span style={{ color: "#ef4444" }}>❌ مرفوض</span>
                          <div style={{ fontSize: 10, color: "#94a3b8" }}>{req.admin_by_name}</div>
                          {req.admin_notes && <div style={{ fontSize: 10, color: "#ef4444" }}>{req.admin_notes}</div>}
                        </div>
                      )}
                    </td>
                    <td>
                      {req.admin_status !== 'approved' ? (
                        <span style={{ color: "#94a3b8" }}>—</span>
                      ) : req.accountant_status === 'pending' ? (
                        <span style={{ color: "#3b82f6" }}>⏳ بانتظار</span>
                      ) : (
                        <div>
                          <span style={{ color: "#22c55e" }}>✅ تم</span>
                          <div style={{ fontSize: 10, color: "#94a3b8" }}>{req.accountant_by_name}</div>
                        </div>
                      )}
                    </td>
                    <td style={{ fontFamily: "monospace", fontSize: 12 }}>{req.accountant_status === 'done' ? (paidDateOf(req) || "—") : <span style={{ color: "#94a3b8" }}>—</span>}</td>{/* v3.4.372 */}
                    <td>
                      {req.accountant_status === 'done' ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: req.payment_method ? "#0f766e" : "#b45309" }}>{req.payment_method ? payMethodLabel(req.payment_method) : "غير محدّدة"}</span>
                          {canExecute && <button type="button" onClick={() => openPaymentEdit(req)} title="تعديل تاريخ/طريقة الصرف" style={{ background: "none", border: "1px solid #e2e8f0", borderRadius: 6, cursor: "pointer", fontSize: 10, padding: "1px 5px", color: "#64748b" }}>✎</button>}
                        </span>
                      ) : <span style={{ color: "#94a3b8" }}>—</span>}
                    </td>
                    <td>
                      <span style={{
                        background: statusStyle.bg,
                        color: statusStyle.color,
                        padding: "3px 10px",
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 600
                      }}>
                        {STATUS_LABELS[status]}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        {/* زر الاعتماد للأدمن */}
                        {canApprove && req.admin_status === 'pending' && (
                          <>
                            <button
                              onClick={() => handleApprove(req.id, 'approved')}
                              style={{
                                padding: "4px 8px",
                                background: "#dcfce7",
                                border: "1px solid #86efac",
                                borderRadius: 6,
                                color: "#166534",
                                cursor: "pointer",
                                fontSize: 11
                              }}
                              title="اعتماد"
                            >
                              <FiCheck size={14} />
                            </button>
                            <button
                              onClick={() => handleApprove(req.id, 'rejected')}
                              style={{
                                padding: "4px 8px",
                                background: "#fee2e2",
                                border: "1px solid #fca5a5",
                                borderRadius: 6,
                                color: "#991b1b",
                                cursor: "pointer",
                                fontSize: 11
                              }}
                              title="رفض"
                            >
                              <FiX size={14} />
                            </button>
                          </>
                        )}
                        {/* زر التنفيذ للمحاسب */}
                        {canExecute && req.admin_status === 'approved' && req.accountant_status === 'pending' && (
                          <button
                            onClick={() => handleExecute(req.id)}
                            style={{
                              padding: "4px 8px",
                              background: "#dbeafe",
                              border: "1px solid #93c5fd",
                              borderRadius: 6,
                              color: "#1e40af",
                              cursor: "pointer",
                              fontSize: 11,
                              display: "flex",
                              alignItems: "center",
                              gap: 4
                            }}
                            title="تنفيذ الصرف"
                          >
                            <FiDollarSign size={14} /> تنفيذ
                          </button>
                        )}
                        {/* زر الأرشفة - للأدمن فقط وبعد البت في الطلب */}
                        {isAdmin && status !== 'pending_admin' && !showArchived && (
                          <button
                            onClick={() => handleArchive(req.id)}
                            style={{
                              padding: "4px 8px",
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: 6,
                              color: "#64748b",
                              cursor: "pointer",
                              fontSize: 11,
                              display: "flex",
                              alignItems: "center",
                              gap: 4
                            }}
                            title="أرشفة الطلب"
                          >
                            📦 أرشفة
                          </button>
                        )}
                        {/* زر إلغاء الأرشفة */}
                        {isAdmin && showArchived && (
                          <button
                            onClick={() => handleUnarchive(req.id)}
                            style={{
                              padding: "4px 8px",
                              background: "#ecfdf5",
                              border: "1px solid #a7f3d0",
                              borderRadius: 6,
                              color: "#059669",
                              cursor: "pointer",
                              fontSize: 11,
                              display: "flex",
                              alignItems: "center",
                              gap: 4
                            }}
                            title="إلغاء الأرشفة"
                          >
                            ↩️ استعادة
                          </button>
                        )}
                        {/* زر الحذف - للأدمن أو من لديه صلاحية الحذف */}
                        {canDelete && (
                          <button
                            onClick={() => handleDelete(req.id)}
                            style={{
                              padding: "4px 8px",
                              background: "#fef2f2",
                              border: "1px solid #fecaca",
                              borderRadius: 6,
                              color: "#dc2626",
                              cursor: "pointer",
                              fontSize: 11,
                              display: "flex",
                              alignItems: "center",
                              gap: 4
                            }}
                            title="حذف الطلب نهائياً"
                          >
                            <FiTrash2 size={12} /> حذف
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* الترقيم */}
      {pagination.total_pages > 1 && (
        <div className="paging">
          <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>السابق</button>
          <span>صفحة {page} من {pagination.total_pages}</span>
          <button disabled={page >= pagination.total_pages} onClick={() => setPage(p => p + 1)}>التالي</button>
        </div>
      )}

      </>)}

      {/* نافذة طلب جديد */}
      {showNewRequest && (
        <NewRequestModal
          onClose={() => setShowNewRequest(false)}
          onSuccess={() => { setShowNewRequest(false); fetchData(); }}
        />
      )}

      {execTarget && <ExecuteModal target={execTarget} onDone={closeExec} onClose={() => closeExec(false)} />}{/* v3.4.372 */}
      {/* نافذة تفاصيل الطلب */}
      {selectedRequest && (
        <RequestDetailModal
          request={selectedRequest}
          onClose={() => setSelectedRequest(null)}
          onApprove={handleApprove}
          onExecute={handleExecute}
          onArchive={handleArchive}
          onUnarchive={handleUnarchive}
          canApprove={canApprove}
          canExecute={canExecute}
          isAdmin={isAdmin}
          showArchived={showArchived}
          onSuccess={() => { setSelectedRequest(null); fetchData(); }}
        />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// نافذة طلب جديد
// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// v3.4.142 — تبويب «دلالات مستحقة»: حجوزات مباعة مقفلة ومُراجَعة ولم تُصرف دلالتها — مع زر طلب صرف (≥30% سداد أو أدمن)
// ══════════════════════════════════════════════════════════════
// v3.4.144 — مراحل المباع غير المصروف (لون لكل مرحلة)
const DUE_STAGES = { // v3.4.375 — ترتيب الظهور: مستحق الصرف ← غير مستحق بعد ← طلب صرف مرفوع ← بانتظار المراجعة
  due:            { label: "مباع مُراجَع — مستحق الصرف", bg: "#dcfce7", color: "#166534", border: "#86efac", row: "#f0fdf4" },
  reviewed:       { label: "مباع مُراجَع — غير مستحق بعد (< 30%)", bg: "#dbeafe", color: "#1e40af", border: "#93c5fd", row: "#eff6ff" },
  requested:      { label: "طلب صرف مرفوع", bg: "#ede9fe", color: "#5b21b6", border: "#c4b5fd", row: "#f5f3ff" },
  pending_review: { label: "مباع — بانتظار المراجعة", bg: "#fef3c7", color: "#92400e", border: "#fcd34d", row: "#fffbeb" },
};
function DueDalalaTab({ canRequest, isAdmin, onRequested }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [stageF, setStageF] = useState(""); // v3.4.144 — تصفية بالمرحلة
  const [hideZero, setHideZero] = useState(false); // v3.4.171 — إخفاء العمليات التي دلالتها 0
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = () => { setRows(null); disbApi.dueDalala().then(r => setRows(r.data.rows || [])).catch(e => { toast.error(e.response?.data?.error || "فشل التحميل"); setRows([]); }); };
  useEffect(load, []);
  const fmtN = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US"));
  const zeroCount = (rows || []).filter(r => !(Number(r.dalala_amount) > 0)).length; // v3.4.171
  const list = (rows || []).filter(r => (!hideZero || Number(r.dalala_amount) > 0) && (!stageF || r.stage === stageF) && (!q.trim() || [r.id, r.client_name, r.unit_label, r.project_name, r.marketer].some(v => String(v || "").toLowerCase().includes(q.trim().toLowerCase()))));
  const counts = Object.fromEntries(Object.keys(DUE_STAGES).map(k => [k, (rows || []).filter(r => r.stage === k).length]));
  // v3.4.144 — طلب الصرف: بعد اعتماد المراجعة فقط؛ وبسداد ≥30% (الأدمن يستطيع قبلها)
  const eligible = (r) => r.review_status === "approved" && (isAdmin || r.paid_pct >= 30);
  const request = async (r) => {
    const def = r.dalala_amount || 0;
    const v = window.prompt(`مبلغ طلب صرف الدلالة للحجز #${r.id} (${r.client_name})\nالدلالة المسجّلة: ${fmtN(def)} ر.س — المسدد: ${r.paid_pct}%`, String(def));
    if (v === null) return;
    const amount = Number(String(v).replace(/[^\d.]/g, ""));
    if (isNaN(amount) || amount < 0 || (amount === 0 && Number(def) > 0)) return toast.error("أدخل مبلغًا صحيحًا"); // v3.4.370 — 0 مقبول عندما الدلالة المسجّلة 0 (عميل شركة مباشر)
    setBusy(r.id);
    try {
      await disbApi.create({ reservation_id: r.id, request_type: "dalala", amount, notes: `طلب من تبويب الدلالات المستحقة — المسدد ${r.paid_pct}%` });
      toast.success(`تم رفع طلب صرف الدلالة للحجز #${r.id}`);
      load(); onRequested && onRequested();
    } catch (e) { toast.error(e.response?.data?.error || "فشل رفع الطلب"); }
    setBusy(null);
  };
  // v3.4.217 — «تم الصرف سابقًا»: الدلالة صُرفت خارج النظام؛ يُسجَّل طلب معتمد إداريًا ويذهب للمحاسب ليؤكد الصرف فيصبح مصروفًا ومعتمدًا في النظام
  const requestPaidBefore = async (r) => {
    const def = r.dalala_amount || 0;
    const v = window.prompt(`تم الصرف سابقًا خارج النظام — حجز #${r.id} (${r.client_name})\nالمبلغ الذي صُرف فعليًا (الدلالة المسجّلة: ${fmtN(def)} ر.س):`, def ? String(def) : "");
    if (v === null) return;
    const amount = Number(String(v).replace(/[^\d.]/g, ""));
    if (isNaN(amount) || amount < 0 || (amount === 0 && Number(def) > 0)) return toast.error("أدخل مبلغًا صحيحًا"); // v3.4.370 — 0 مقبول عندما الدلالة المسجّلة 0 (عميل شركة مباشر)
    const ref = window.prompt("تاريخ الصرف أو مرجعه (اختياري — مثال: 2026-03-15 تحويل بنكي):", "");
    if (ref === null) return;
    setBusy(r.id);
    try {
      await disbApi.create({ reservation_id: r.id, request_type: "dalala", amount, paid_externally: true, notes: `تم الصرف سابقًا خارج النظام${ref.trim() ? " — " + ref.trim() : ""}` });
      toast.success(`سُجّل الصرف السابق للحجز #${r.id} — بانتظار تأكيد المحاسب`);
      load(); onRequested && onRequested();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التسجيل"); }
    setBusy(null);
  };
  const badge = (t, bg, c) => <span style={{ fontSize: 10.5, fontWeight: 700, padding: "2px 8px", borderRadius: 10, background: bg, color: c, whiteSpace: "nowrap" }}>{t}</span>;
  const pctBar = (p) => (
    <div title={`${p}% من سعر البيع`} style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <div style={{ width: 70, height: 7, background: "#e2e8f0", borderRadius: 4, overflow: "hidden" }}><div style={{ width: `${Math.min(100, p)}%`, height: "100%", background: p >= 30 ? "#16a34a" : "#f59e0b" }} /></div>
      <span style={{ fontFamily: "monospace", fontWeight: 800, color: p >= 30 ? "#166534" : "#b45309" }}>{p}%</span>
    </div>
  );
  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <span style={{ fontSize: 14, fontWeight: 800, color: "#1e293b" }}>💰 المباع غير المصروف</span>
        <span style={{ fontSize: 11, color: "#64748b" }}>كل حجز تحوّلت وحدته إلى مُباع وقُفل ولم تُصرف دلالته — بمرحلته: بانتظار المراجعة ← مُراجَع ← مستحق الصرف (سداد ≥30%) ← طلب مرفوع. الأدمن يستطيع الطلب قبل 30% بعد المراجعة.</span>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 حجز / عميل / وحدة / مسوّق" style={{ padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit", minWidth: 220, marginRight: "auto" }} />
        {/* v3.4.171 — إخفاء/إظهار العمليات التي دلالتها 0 */}
        <button className="btn-filter" onClick={() => setHideZero(v => !v)} title={hideZero ? "إظهار العمليات التي دلالتها 0" : "إخفاء العمليات التي دلالتها 0"}
          style={hideZero ? { background: "#7c3aed", color: "#fff", borderColor: "#7c3aed" } : undefined}>
          {hideZero ? "👁 إظهار دلالة 0" : "🚫 إخفاء دلالة 0"} ({zeroCount})
        </button>
        <button className="btn-filter" onClick={load}><FiRefreshCw size={14} /> تحديث</button>
        <span className="count">{list.length} حجز</span>
      </div>
      {/* v3.4.144 — شرائح المراحل (تصفية) */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        {Object.entries(DUE_STAGES).map(([k, s]) => (
          <div key={k} onClick={() => setStageF(f => f === k ? "" : k)} title="اضغط للتصفية"
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 12px", borderRadius: 10, cursor: "pointer", background: s.bg, color: s.color, border: `2px solid ${stageF === k ? s.color : s.border}`, fontSize: 11.5, fontWeight: 700 }}>
            <span style={{ width: 9, height: 9, borderRadius: "50%", background: s.color, display: "inline-block" }} />{s.label}
            <span style={{ fontFamily: "monospace", fontWeight: 800, background: "#fff", borderRadius: 8, padding: "0 6px" }}>{counts[k]}</span>
          </div>
        ))}
        {stageF && <button onClick={() => setStageF("")} style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 11 }}>✕ إلغاء التصفية</button>}
      </div>
      {rows === null ? <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>⏳ جاري التحميل...</div> : list.length === 0 ? (
        <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>لا توجد دلالات مستحقة حاليًا</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead><tr style={{ background: "#f1f5f9" }}>
              {["المرحلة", "رقم الحجز", "التاريخ", "العميل", "المشروع / الوحدة", "نوع العملية", "المسوّقون ونسبهم", "الدلالة", "سعر البيع", "المدفوع للوحدة", "نسبة السداد", "حالة الطلب", ""].map((h, i) => <th key={i} style={{ padding: "7px 8px", textAlign: "right", fontWeight: 700, color: "#334155", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {list.map(r => (
                <React.Fragment key={r.id}>
                  <tr style={{ borderBottom: "1px solid #f1f5f9", background: (DUE_STAGES[r.stage] || {}).row || "#fff", borderRight: `4px solid ${(DUE_STAGES[r.stage] || {}).color || "#e2e8f0"}` }}>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{badge((DUE_STAGES[r.stage] || {}).label || r.stage, (DUE_STAGES[r.stage] || {}).bg || "#f1f5f9", (DUE_STAGES[r.stage] || {}).color || "#334155")}{r.review_status === "pending" && <div style={{ fontSize: 9.5, color: "#92400e", marginTop: 2 }}>مراجعة معلّقة في طلبات الحجز</div>}</td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}><a href={`/?edit=${r.id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#1d4ed8", fontWeight: 800 }}>#{r.id}</a></td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap", color: "#64748b" }}>{r.date ? new Date(r.date).toLocaleDateString("en-GB") : "—"}</td>
                    <td style={{ padding: "6px 8px", fontWeight: 700 }}>{r.client_name || "—"}</td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{r.project_name || "—"}{r.unit_label ? <> · <a href={`/projects?id=${r.project_id}&unit=${r.unit_id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#1d4ed8", fontWeight: 700 }}>{r.unit_label}</a></> : null}</td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap", fontSize: 11 }}>{r.operation_type || "—"}</td>
                    <td style={{ padding: "6px 8px", minWidth: 200 }}>
                      {r.marketers.length ? r.marketers.map((m, i) => (
                        <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 11 }}>
                          <span>{m.type === "external" ? "🌐" : "🏠"} {m.name}</span>
                          <span style={{ fontFamily: "monospace", color: "#0f172a" }}>{m.pct != null ? `${m.pct}%` : "—"}{m.amount ? ` = ${fmtN(m.amount)}` : ""}</span>
                        </div>
                      )) : <span style={{ color: "#94a3b8" }}>—</span>}
                      {r.dalilak_pct > 0 && <div style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 11, color: "#475569" }}><span>دليلك</span><span style={{ fontFamily: "monospace" }}>{r.dalilak_pct}% = {fmtN(r.dalilak_share)}</span></div>}
                      {r.company_residual_pct > 0 && <div style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 11, color: "#475569" }}><span>الإدارة والشركة</span><span style={{ fontFamily: "monospace" }}>{r.company_residual_pct}% = {fmtN(r.company_residual)}</span></div>}
                    </td>
                    <td style={{ padding: "6px 8px", fontFamily: "monospace", fontWeight: 800, color: "#b45309", whiteSpace: "nowrap" }}>{fmtN(r.dalala_amount)}</td>
                    <td style={{ padding: "6px 8px", fontFamily: "monospace", whiteSpace: "nowrap" }}>{fmtN(r.sale_price)}</td>
                    <td style={{ padding: "6px 8px", fontFamily: "monospace", color: "#166534", whiteSpace: "nowrap" }}>{fmtN(r.paid)}</td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{pctBar(r.paid_pct)}</td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>
                      {r.request ? badge(`طلب #${r.request.id} — ${r.request.status}`, r.request.status === "مرفوض" ? "#fee2e2" : "#fef3c7", r.request.status === "مرفوض" ? "#991b1b" : "#92400e") : badge("لم يُرفع طلب", "#f1f5f9", "#64748b")}
                    </td>
                    <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>
                      {canRequest && (!r.request || r.request.status === "مرفوض") && (
                        <button onClick={() => request(r)} disabled={!eligible(r) || busy === r.id}
                          title={eligible(r) ? "رفع طلب صرف الدلالة" : r.review_status !== "approved" ? "غير متاح — بانتظار اعتماد مراجعة المباع" : `غير متاح — المسدد ${r.paid_pct}% (المطلوب 30%)`}
                          style={{ padding: "5px 12px", background: eligible(r) ? "#166534" : "#e2e8f0", color: eligible(r) ? "#fff" : "#94a3b8", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: eligible(r) ? "pointer" : "not-allowed", fontFamily: "inherit" }}>
                          {busy === r.id ? "…" : "$ طلب صرف"}
                        </button>
                      )}
                      {canRequest && (!r.request || r.request.status === "مرفوض") && r.review_status === "approved" && (
                        <button onClick={() => requestPaidBefore(r)} disabled={busy === r.id} title="الدلالة صُرفت خارج النظام سابقًا — يذهب للمحاسب ليؤكد الصرف"
                          style={{ padding: "5px 10px", marginInlineStart: 6, background: "#eff6ff", color: "#1e40af", border: "1px solid #bfdbfe", borderRadius: 7, fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                          ✔ تم الصرف سابقًا
                        </button>
                      )}{/* v3.4.217 */}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ═══════ v3.4.373 — العرابين المستحقة الاسترداد: عمليات «لم تتم» ولها عربون لم يُرجَع ═══════
const ARBOUN_BUCKETS = [ // v3.4.379
  ["completed", "✅ المستحقة الاسترداد بعد اكتمال العملية", "#166534", "#dcfce7", "#86efac"],
  ["pending", "⏳ العرابين بانتظار إكمال الإجراءات", "#92400e", "#fef3c7", "#fcd34d"],
  ["cancelled", "❌ العرابين للعمليات الملغاة", "#991b1b", "#fee2e2", "#fca5a5"],
];
const bucketOf = (r) => r.bucket || (/لم تتم/.test(String(r.operation_status || "")) ? "cancelled" : /تمت/.test(String(r.operation_status || "")) ? "completed" : "pending");
function ArbounDueTab({ canRequest, onRequested }) {
  const [rows, setRows] = useState(null); const [q, setQ] = useState(""); const [busy, setBusy] = useState(null);
  const [bucket, setBucket] = useState("completed"); // v3.4.379
  const load = useCallback(() => disbApi.dueArboun().then(r => setRows(r.data?.rows || [])).catch(e => { toast.error(e.response?.data?.error || e.message); setRows([]); }), []);
  useEffect(() => { load(); }, [load]);
  const list = (rows || []).filter(r => bucketOf(r) === bucket && (!q.trim() || [r.id, r.client_name, r.unit_label, r.project_name, r.marketer].some(v => String(v || "").includes(q.trim())))); // v3.4.379
  const countOf = (b) => (rows || []).filter(r => bucketOf(r) === b).length;
  const request = async (r) => {
    const v = window.prompt(`مبلغ إرجاع العربون للحجز #${r.id} (${r.client_name})\nالعربون المسجّل: ${fmtN0(r.deposit_amount)} ر.س`, String(r.deposit_amount || 0));
    if (v === null) return; const amount = Number(String(v).replace(/[^\d.]/g, ""));
    if (isNaN(amount) || amount < 0) return toast.error("أدخل مبلغًا صحيحًا");
    setBusy(r.id);
    try { await disbApi.create({ reservation_id: r.id, request_type: "arboun", amount, notes: "طلب من تبويب العرابين المستحقة الاسترداد" }); toast.success(`تم رفع طلب إرجاع العربون للحجز #${r.id}`); load(); onRequested && onRequested(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل رفع الطلب"); }
    setBusy(null);
  };
  const th = { padding: "8px 10px", fontSize: 11.5, color: "#64748b", fontWeight: 800, textAlign: "start", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", fontSize: 12.5, borderBottom: "1px solid #f1f5f9" };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <div><b style={{ fontSize: 14 }}>🔵 استرداد العرابين</b><div style={{ fontSize: 11.5, color: "#64748b" }}>كل الحجوزات التي لها عربون مسجّل ولم يُرجَع — مصنّفة حسب حالة العملية؛ الإرجاع يُرفع للعمليات المكتملة أو الملغاة</div></div>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 حجز / عميل / وحدة / مسوّق" style={{ marginInlineStart: "auto", padding: "7px 12px", border: "1px solid #e2e8f0", borderRadius: 999, fontFamily: "inherit", fontSize: 12.5, width: 260 }} />
        <button onClick={load} style={{ padding: "7px 12px", borderRadius: 999, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>⟳ تحديث</button>
        <span style={{ fontSize: 12, color: "#64748b" }}>{rows ? `${list.length} حجز` : "…"}</span>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>{/* v3.4.379 — التبويبات الفرعية */}
        {ARBOUN_BUCKETS.map(([k, l, color, bg, border]) => <button key={k} onClick={() => setBucket(k)} style={{ padding: "7px 14px", borderRadius: 999, border: `1.5px solid ${bucket === k ? color : border}`, background: bucket === k ? color : bg, color: bucket === k ? "#fff" : color, fontWeight: 800, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", display: "inline-flex", gap: 6, alignItems: "center" }}>{l}<span style={{ fontSize: 11, background: bucket === k ? "rgba(255,255,255,.25)" : "#fff", borderRadius: 999, padding: "0 7px" }}>{countOf(k)}</span></button>)}
      </div>
      {bucket === "pending" && <div style={{ fontSize: 11.5, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "6px 10px", marginBottom: 8 }}>هذه العمليات لم تكتمل بعد — يُرفع طلب الإرجاع عندما تتحول حالتها إلى «تمت العملية» أو «لم تتم العملية»</div>}
      {rows && list.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>لا توجد عرابين في هذا التصنيف</div>}
      {list.length > 0 && <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "#f8fafc" }}>{["رقم الحجز", "العميل", "الوحدة", "المشروع", "المسوّق", "التاريخ", "حالة العملية", "قيمة الحجز", "العربون", "حالة الطلب", ""].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>{list.map(r => (
            <tr key={r.id}>
              <td style={{ ...td, fontFamily: "monospace", fontWeight: 700 }}><a href={`/?edit=${r.id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#1e40af" }}>#{r.id}</a></td>
              <td style={td}>{r.client_name}</td><td style={{ ...td, fontFamily: "monospace" }}>{r.unit_label || "—"}</td><td style={td}>{r.project_name || "—"}</td><td style={td}>{r.marketer || "—"}</td>
              <td style={{ ...td, fontFamily: "monospace" }}>{r.date ? String(r.date).slice(0, 10) : "—"}</td>
              <td style={{ ...td, fontSize: 11.5, color: "#475569" }}>{r.operation_status || "—"}</td>{/* v3.4.379 */}
              <td style={{ ...td, fontFamily: "monospace" }}>{fmtN0(r.value)}</td>
              <td style={{ ...td, fontFamily: "monospace", fontWeight: 800, color: "#1d4ed8" }}>{fmtN0(r.deposit_amount)} ر.س</td>
              <td style={td}>{r.request ? <span style={{ fontSize: 11, fontWeight: 800, color: r.request.status === "مرفوض" ? "#b91c1c" : "#b45309", background: r.request.status === "مرفوض" ? "#fee2e2" : "#fef3c7", borderRadius: 999, padding: "2px 8px" }}>{r.request.status} · {fmtN0(r.request.amount)}</span> : <span style={{ fontSize: 11, color: "#64748b" }}>{bucketOf(r) === "pending" ? "بانتظار اكتمال العملية" : "مستحق — لا طلب"}</span>}</td>
              <td style={td}>{canRequest && r.stage === "due" && <button onClick={() => request(r)} disabled={busy === r.id} style={{ padding: "6px 12px", borderRadius: 8, border: "none", background: "#1d4ed8", color: "#fff", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>{busy === r.id ? "…" : "🔵 رفع طلب إرجاع"}</button>}</td>
            </tr>))}</tbody>
        </table>
      </div>}
    </div>
  );
}
// ═══════ v3.4.373 — نافذة طلب إرجاع مبلغ إعادة بيع: الأرقام تُحسب تلقائيًا حسب نوع إعادة البيع ويمكن تعديلها ═══════
function ResaleRefundModal({ cycle, onClose, onSuccess }) {
  const c0 = cycle.calc || {};
  const [base, setBase] = useState(String(c0.base ?? 0)); const [d1, setD1] = useState(String(c0.d1 ?? 0)); const [d2, setD2] = useState(String(c0.d2 ?? 0));
  const [amount, setAmount] = useState(String(c0.amount ?? 0)); const [touched, setTouched] = useState(false); const [notes, setNotes] = useState(""); const [busy, setBusy] = useState(false);
  const n = (v) => Number(String(v).replace(/[^\d.]/g, "")) || 0;
  const auto = Math.max(0, Math.round((n(base) - n(d1) - n(d2)) * 100) / 100);
  useEffect(() => { if (!touched) setAmount(String(auto)); }, [auto, touched]);
  const inp = { width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", fontSize: 13, boxSizing: "border-box", textAlign: "end" };
  const submit = async () => {
    if (n(amount) < 0) return toast.error("مبلغ غير صحيح");
    setBusy(true);
    try {
      await disbApi.create({ reservation_id: cycle.prev_reservation_id, request_type: "resale_refund", transfer_id: cycle.transfer_id, amount: n(amount), notes: notes.trim() || null,
        calc: { ...c0, base: n(base), d1: n(d1), d2: n(d2), amount: n(amount), edited: touched || n(base) !== c0.base || n(d1) !== c0.d1 || n(d2) !== c0.d2 } });
      toast.success(`تم رفع طلب إرجاع مبلغ إعادة البيع للعميل ${cycle.prev_client || ""}`); onSuccess && onSuccess(); onClose();
    } catch (e) { toast.error(e.response?.data?.error || "فشل رفع الطلب", { duration: 8000 }); }
    setBusy(false);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", zIndex: 1150, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={() => !busy && onClose()}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: 560, maxWidth: "100%", padding: 20, maxHeight: "94vh", overflowY: "auto" }}>
        <h3 style={{ margin: "0 0 4px", fontSize: 15 }}>↩️ طلب إرجاع مبلغ إعادة بيع — {cycle.unit_label} · {cycle.project_name}</h3>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 12 }}>الإرجاع للعميل السابق <b>{cycle.prev_client}</b> (حجز #{cycle.prev_reservation_id}) — المشتري الجديد <b>{cycle.new_client}</b> سدّد {cycle.new_paid_pct}% ({fmtN0(cycle.new_paid)} من {fmtN0(cycle.new_price)})</div>
        <div style={{ background: cycle.resale_kind === 2 ? "#fff7ed" : "#f0fdf4", border: "1px solid " + (cycle.resale_kind === 2 ? "#fed7aa" : "#bbf7d0"), borderRadius: 10, padding: "8px 12px", fontSize: 12, marginBottom: 12 }}>
          <b>{cycle.resale_kind === 2 ? "إعادة بيع - 2" : "إعادة بيع - 1"}:</b> {cycle.resale_kind === 2 ? "العميل السابق لم يسدّد كاملًا وأعاد الوحدة — يُرجَع له ما دفعه في دورته بعد خصم الدلالة التي صُرفت في بيعته السابقة" : "العميل السابق سدّد كاملًا وباع بسعر أعلى — يُرجَع له إجمالي سعر إعادة البيع بعد خصم رسوم الشركة وعمولة المسوق"}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: "8px 12px", alignItems: "center", fontSize: 13 }}>
          <span>{c0.base_label || "الأساس"}</span><input value={base} onChange={e => setBase(e.target.value)} style={inp} />
          <span>− {c0.d1_label || "خصم 1"}</span><input value={d1} onChange={e => setD1(e.target.value)} style={inp} />
          <span>− {c0.d2_label || "خصم 2"}</span><input value={d2} onChange={e => setD2(e.target.value)} style={inp} />
          <span style={{ fontWeight: 900, color: "#0f766e" }}>= مبلغ الإرجاع {touched && n(amount) !== auto && <span style={{ fontSize: 10.5, color: "#b45309", fontWeight: 700 }}>(معدّل يدويًا — المحسوب {fmtN0(auto)})</span>}</span>
          <input value={amount} onChange={e => { setTouched(true); setAmount(e.target.value); }} style={{ ...inp, fontWeight: 900, color: "#0f766e", borderColor: "#99f6e4" }} />
        </div>
        {touched && <button type="button" onClick={() => { setTouched(false); setAmount(String(auto)); }} style={{ marginTop: 6, fontSize: 11, background: "none", border: "none", color: "#1e40af", cursor: "pointer", fontFamily: "inherit" }}>↺ استعادة المبلغ المحسوب</button>}
        <input value={notes} onChange={e => setNotes(e.target.value)} placeholder="ملاحظات (اختياري)" style={{ ...inp, textAlign: "start", marginTop: 12 }} />
        <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
          <button onClick={submit} disabled={busy || !cycle.new_paid_full} title={cycle.new_paid_full ? "" : "لا يمكن رفع الطلب قبل سداد المشتري الجديد كاملًا"} style={{ flex: 1, padding: "10px 16px", borderRadius: 8, border: "none", background: cycle.new_paid_full ? "#b45309" : "#cbd5e1", color: "#fff", fontWeight: 900, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "…" : "↩️ رفع طلب الإرجاع"}</button>
          <button onClick={onClose} disabled={busy} style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f1f5f9", cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
        {!cycle.new_paid_full && <div style={{ fontSize: 11.5, color: "#b91c1c", marginTop: 8 }}>⚠️ الطلب متاح فقط بعد سداد المشتري الجديد كاملًا في آخر دورة إعادة بيع</div>}
      </div>
    </div>
  );
}
// ═══════ v3.4.376 — نافذة تفاصيل دورة إعادة البيع ═══════
function ResaleCycleDetailModal({ transferId, canRequest, onClose, onRequested }) {
  const [d, setD] = useState(null); const [err, setErr] = useState(null); const [refund, setRefund] = useState(false);
  const load = useCallback(() => disbApi.resaleCycleDetails(transferId).then(r => setD(r.data)).catch(e => setErr(e.response?.data?.error || e.message)), [transferId]);
  useEffect(() => { load(); }, [load]);
  const fmtD = (v) => (v ? String(v).slice(0, 10) : "—");
  const sum = (arr) => (arr || []).reduce((a, p) => a + (Number(p.amount) || 0), 0);
  const Side = ({ title, color, info, calc }) => (
    <div style={{ border: `1px solid ${color}44`, borderRadius: 12, overflow: "hidden", background: "#fff" }}>
      <div style={{ background: `${color}14`, padding: "8px 12px", fontWeight: 900, color, fontSize: 13.5 }}>{title}</div>
      <div style={{ padding: "8px 12px", display: "grid", gap: 4, fontSize: 12.5 }}>
        {info.map(([k, v, strong]) => <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 10 }}><span style={{ color: "#64748b" }}>{k}</span><b style={{ fontFamily: strong ? "monospace" : "inherit", color: strong ? "#0f172a" : "#334155" }}>{v}</b></div>)}
      </div>
      {calc}
    </div>
  );
  const PayTable = ({ rows, empty }) => rows && rows.length ? (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
      <thead><tr style={{ background: "#f8fafc" }}>{["#", "التاريخ", "المبلغ", "ملاحظة"].map(h => <th key={h} style={{ padding: "5px 8px", textAlign: "start", color: "#64748b", fontWeight: 800, borderBottom: "1px solid #e2e8f0" }}>{h}</th>)}</tr></thead>
      <tbody>{rows.map((p, i) => <tr key={p.id}><td style={{ padding: "5px 8px", color: "#94a3b8" }}>{i + 1}</td><td style={{ padding: "5px 8px", fontFamily: "monospace" }}>{fmtD(p.payment_date)}</td><td style={{ padding: "5px 8px", fontFamily: "monospace", fontWeight: 700, color: "#166534" }}>{fmtN0(p.amount)}</td><td style={{ padding: "5px 8px", color: "#64748b", fontSize: 11 }}>{p.notes || (p.receipt_url ? <a href={p.receipt_url} target="_blank" rel="noreferrer">إيصال ↗</a> : "—")}</td></tr>)}
        <tr style={{ background: "#f0fdf4" }}><td colSpan={2} style={{ padding: "6px 8px", fontWeight: 900 }}>الإجمالي</td><td style={{ padding: "6px 8px", fontFamily: "monospace", fontWeight: 900, color: "#166534" }}>{fmtN0(sum(rows))}</td><td /></tr></tbody>
    </table>) : <div style={{ fontSize: 11.5, color: "#94a3b8", padding: "6px 8px" }}>{empty}</div>;
  const DisbList = ({ rows }) => rows && rows.length ? <div style={{ display: "grid", gap: 3 }}>{rows.map(x => <div key={x.id} style={{ fontSize: 11.5, display: "flex", gap: 8, alignItems: "center" }}><span style={{ fontWeight: 800 }}>{TYPE_BADGE[x.request_type] || x.request_type}</span><span style={{ fontFamily: "monospace" }}>{fmtN0(x.amount)}</span><span style={{ fontSize: 10.5, color: x.status === "تم الصرف" ? "#166534" : "#b45309", background: x.status === "تم الصرف" ? "#dcfce7" : "#fef3c7", borderRadius: 999, padding: "1px 7px" }}>{x.status}{x.paid_at ? " · " + fmtD(x.paid_at) : ""}{x.payment_method ? " · " + payMethodLabel(x.payment_method) : ""}</span></div>)}</div> : <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا طلبات صرف</div>;
  const c = d?.cycle; const pr = d?.prev; const nx = d?.next;
  const prevDalalaPaid = sum((pr?.disbursements || []).filter(x => x.request_type === "dalala" && x.status === "تم الصرف"));
  const newDalalaPaid = sum((nx?.disbursements || []).filter(x => x.request_type === "dalala" && x.status === "تم الصرف"));
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", zIndex: 1140, display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }} onClick={onClose}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#f8fafc", borderRadius: 14, width: 1100, maxWidth: "100%", maxHeight: "94vh", overflowY: "auto", padding: 18 }}>
        {!d && !err && <div style={{ color: "#94a3b8", textAlign: "center", padding: 30 }}>جاري التحميل…</div>}
        {err && <div style={{ color: "#b91c1c", padding: 20 }}>{err}</div>}
        {d && (<>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>↩️ دورة إعادة بيع — {c.unit_label} · {c.project_name}</h3>
            <span style={{ fontSize: 11, fontWeight: 800, color: c.resale_kind === 2 ? "#9a3412" : "#166534", background: c.resale_kind === 2 ? "#ffedd5" : "#dcfce7", borderRadius: 999, padding: "2px 10px" }}>{c.resale_kind === 2 ? "إعادة بيع - 2" : "إعادة بيع - 1"}</span>
            <span style={{ fontSize: 11.5, color: "#64748b" }}>نُفّذت {fmtD(c.executed_at)}{!c.is_latest ? " · دورة سابقة (ليست الأخيرة)" : ""}</span>
            <button onClick={onClose} style={{ marginInlineStart: "auto", background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#64748b" }}>✕</button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Side title={`👤 المشتري الأول (السابق): ${pr?.reservation?.client_name || c.prev_client || "—"}`} color="#1d4ed8"
              info={[["رقم الحجز", pr?.reservation ? "#" + pr.reservation.id : "—"], ["تاريخ الحجز", fmtD(pr?.reservation?.date)], ["اشترى بـ (سعر البيع)", fmtN0(pr?.reservation?.value ?? c.prev_value) + " ر.س", true], ["الدلالة المسجّلة", fmtN0(pr?.reservation?.dalala_amount) + " ر.س", true], ["الدلالة المصروفة فعليًا", fmtN0(prevDalalaPaid || c.prev_dalala_paid) + " ر.س", true], ["إجمالي ما دفعه", fmtN0(sum(pr?.payments) || c.prev_paid) + " ر.س", true], ["حالة العملية", pr?.reservation?.operation_status || "—"]]}
              calc={<div style={{ padding: "0 12px 10px" }}><div style={{ fontSize: 12, fontWeight: 800, color: "#334155", margin: "6px 0 4px" }}>💵 الدفعات ({(pr?.payments || []).length})</div><PayTable rows={pr?.payments} empty="لا دفعات مسجّلة" /><div style={{ fontSize: 12, fontWeight: 800, color: "#334155", margin: "8px 0 4px" }}>💰 طلبات الصرف</div><DisbList rows={pr?.disbursements} /></div>} />
            <Side title={`👤 المشتري الجديد: ${nx?.reservation?.client_name || c.new_client || "—"}`} color="#0f766e"
              info={[["رقم الحجز", nx?.reservation ? "#" + nx.reservation.id : "—"], ["تاريخ الحجز", fmtD(nx?.reservation?.date)], ["اشترى بـ (سعر إعادة البيع)", fmtN0(c.new_price) + " ر.س", true], ["صافي سعر إعادة البيع", fmtN0(c.resale_net_price) + " ر.س", true], [c.resale_kind === 2 ? "عمولة المسوق المدفوعة سابقًا" : "عمولة المسوق على البيعة", fmtN0(c.resale_marketer_commission) + " ر.س", true], [c.resale_kind === 2 ? "رسوم الشركة (عمولة المسوق الجديد)" : "رسوم الشركة", fmtN0(c.resale_company_fees) + " ر.س", true], ["الدلالة المسجّلة على الحجز الجديد", fmtN0(nx?.reservation?.dalala_amount) + " ر.س", true], ["الدلالة المصروفة فعليًا", fmtN0(newDalalaPaid) + " ر.س", true], ["إجمالي ما دفعه", `${fmtN0(c.new_paid)} ر.س (${c.new_paid_pct}%)${c.new_paid_full ? " ✓ كامل" : ""}`, true]]}
              calc={<div style={{ padding: "0 12px 10px" }}><div style={{ fontSize: 12, fontWeight: 800, color: "#334155", margin: "6px 0 4px" }}>💵 الدفعات ({(nx?.payments || []).length})</div><PayTable rows={nx?.payments} empty="لا دفعات مسجّلة" /><div style={{ fontSize: 12, fontWeight: 800, color: "#334155", margin: "8px 0 4px" }}>💰 طلبات الصرف</div><DisbList rows={nx?.disbursements} /></div>} />
          </div>
          <div style={{ marginTop: 12, background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 12, padding: "10px 14px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            <div style={{ fontSize: 12.5 }}><b style={{ color: "#9a3412" }}>↩️ مبلغ الإرجاع المحسوب للعميل السابق:</b> <b style={{ fontFamily: "monospace", fontSize: 15, color: "#0f766e" }}>{fmtN0(c.calc?.amount)} ر.س</b><div style={{ fontSize: 11, color: "#64748b" }}>{c.calc?.base_label}: {fmtN0(c.calc?.base)} − {c.calc?.d1_label}: {fmtN0(c.calc?.d1)} − {c.calc?.d2_label}: {fmtN0(c.calc?.d2)}</div></div>
            <div style={{ marginInlineStart: "auto", display: "flex", gap: 8, alignItems: "center" }}>
              {c.request ? <span style={{ fontSize: 12, fontWeight: 800, color: c.request.status === "تم الإرجاع" ? "#166534" : "#b45309", background: c.request.status === "تم الإرجاع" ? "#dcfce7" : "#fef3c7", borderRadius: 999, padding: "3px 10px" }}>طلب الإرجاع: {c.request.status} · {fmtN0(c.request.amount)}</span> : null}
              {canRequest && c.is_latest && (!c.request || c.request.status === "مرفوض") && <button onClick={() => setRefund(true)} disabled={!c.new_paid_full} title={c.new_paid_full ? "" : "بعد سداد المشتري الجديد كاملًا"} style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: c.new_paid_full ? "#b45309" : "#cbd5e1", color: "#fff", fontWeight: 900, fontSize: 12.5, cursor: c.new_paid_full ? "pointer" : "not-allowed", fontFamily: "inherit" }}>↩️ رفع طلب إرجاع</button>}
            </div>
          </div>
        </>)}
        {refund && c && <ResaleRefundModal cycle={c} onClose={() => setRefund(false)} onSuccess={() => { load(); onRequested && onRequested(); }} />}
      </div>
    </div>
  );
}
// ═══════ v3.4.373 — عمليات إعادة البيع (الدورات المنفذة) ═══════
function ResaleCyclesTab({ canRequest, onRequested }) {
  const [rows, setRows] = useState(null); const [q, setQ] = useState(""); const [modal, setModal] = useState(null); const [onlyLatest, setOnlyLatest] = useState(true);
  const [detail, setDetail] = useState(null); // v3.4.376 — دورة مفتوحة للتفاصيل
  const load = useCallback(() => disbApi.resaleCycles().then(r => setRows(r.data?.rows || [])).catch(e => { toast.error(e.response?.data?.error || e.message); setRows([]); }), []);
  useEffect(() => { load(); }, [load]);
  const list = (rows || []).filter(r => (!onlyLatest || r.is_latest) && (!q.trim() || [r.unit_label, r.project_name, r.prev_client, r.new_client, r.prev_reservation_id, r.new_reservation_id].some(v => String(v || "").includes(q.trim()))));
  const th = { padding: "8px 10px", fontSize: 11.5, color: "#64748b", fontWeight: 800, textAlign: "start", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", fontSize: 12.5, borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const kindChip = (k) => <span style={{ fontSize: 10.5, fontWeight: 800, color: k === 2 ? "#9a3412" : "#166534", background: k === 2 ? "#ffedd5" : "#dcfce7", borderRadius: 999, padding: "1px 8px" }}>{k === 2 ? "إعادة بيع - 2" : "إعادة بيع - 1"}</span>;
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <div><b style={{ fontSize: 14 }}>↩️ عمليات إعادة البيع</b><div style={{ fontSize: 11.5, color: "#64748b" }}>دورات إعادة البيع المنفذة — اضغط على أي عملية لعرض كل التفاصيل (الطرفان، الدفعات، الدلالات، الرسوم)؛ ويُرفع منها طلب إرجاع المبلغ للعميل السابق (آخر دورة للوحدة فقط، وبعد سداد المشتري الجديد كاملًا). الأرقام تُحسب تلقائيًا حسب نوع إعادة البيع وتُعدَّل عند الرفع</div></div>
        <label style={{ marginInlineStart: "auto", fontSize: 12, display: "inline-flex", gap: 6, alignItems: "center" }}><input type="checkbox" checked={onlyLatest} onChange={e => setOnlyLatest(e.target.checked)} /> آخر دورة لكل وحدة فقط</label>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 وحدة / عميل / حجز" style={{ padding: "7px 12px", border: "1px solid #e2e8f0", borderRadius: 999, fontFamily: "inherit", fontSize: 12.5, width: 220 }} />
        <button onClick={load} style={{ padding: "7px 12px", borderRadius: 999, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>⟳ تحديث</button>
        <span style={{ fontSize: 12, color: "#64748b" }}>{rows ? `${list.length} عملية` : "…"}</span>
      </div>
      {rows && list.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>لا توجد عمليات إعادة بيع منفذة</div>}
      {list.length > 0 && <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "#f8fafc" }}>{["الوحدة", "النوع", "العميل السابق (المستفيد)", "المشتري الجديد", "سداد المشتري الجديد", "المبلغ المحسوب للإرجاع", "حالة الطلب", ""].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>{list.map(r => (
            <tr key={r.transfer_id} onClick={() => setDetail(r.transfer_id)} title="اضغط لعرض كل التفاصيل" style={{ opacity: r.is_latest ? 1 : 0.6, cursor: "pointer" }}>{/* v3.4.376 */}
              <td style={td}><b style={{ fontFamily: "monospace" }}>{r.unit_label}</b><div style={{ fontSize: 11, color: "#64748b" }}>{r.project_name}</div><div style={{ fontSize: 10.5, color: "#94a3b8" }}>نُفّذت {r.executed_at ? String(r.executed_at).slice(0, 10) : "—"}{!r.is_latest && " · دورة سابقة"}</div></td>
              <td style={td}>{kindChip(r.resale_kind)}</td>
              <td style={td}>{r.prev_client || "—"}<div style={{ fontSize: 10.5, color: "#64748b" }}>حجز #{r.prev_reservation_id} · دفع {fmtN0(r.prev_paid)}{r.resale_kind === 2 ? ` · دلالة صُرفت ${fmtN0(r.prev_dalala_paid)}` : ""}</div></td>
              <td style={td}>{r.new_client || "—"}<div style={{ fontSize: 10.5, color: "#64748b" }}>حجز #{r.new_reservation_id} · السعر {fmtN0(r.new_price)}</div></td>
              <td style={td}><span style={{ fontWeight: 800, color: r.new_paid_full ? "#166534" : "#b45309" }}>{r.new_paid_full ? "✓ سدّد كاملًا" : `${r.new_paid_pct}%`}</span><div style={{ fontSize: 10.5, color: "#64748b" }}>{fmtN0(r.new_paid)} ر.س</div></td>
              <td style={{ ...td, fontFamily: "monospace", fontWeight: 900, color: "#0f766e" }}>{fmtN0(r.calc?.amount)} ر.س<div style={{ fontSize: 10, color: "#94a3b8", fontFamily: "inherit", fontWeight: 500 }}>{r.calc?.base_label}: {fmtN0(r.calc?.base)} − {fmtN0(r.calc?.d1)} − {fmtN0(r.calc?.d2)}</div></td>
              <td style={td}>{r.request ? <span style={{ fontSize: 11, fontWeight: 800, color: r.request.status === "مرفوض" ? "#b91c1c" : r.request.status === "تم الإرجاع" ? "#166534" : "#b45309", background: r.request.status === "مرفوض" ? "#fee2e2" : r.request.status === "تم الإرجاع" ? "#dcfce7" : "#fef3c7", borderRadius: 999, padding: "2px 8px" }}>{r.request.status} · {fmtN0(r.request.amount)}</span> : <span style={{ fontSize: 11, color: "#64748b" }}>لا طلب</span>}</td>
              <td style={td}>{canRequest && r.is_latest && (!r.request || r.request.status === "مرفوض") && <button onClick={(e) => { e.stopPropagation(); setModal(r); }} disabled={!r.new_paid_full} title={r.new_paid_full ? "" : "بعد سداد المشتري الجديد كاملًا"} style={{ padding: "6px 12px", borderRadius: 8, border: "none", background: r.new_paid_full ? "#b45309" : "#cbd5e1", color: "#fff", fontWeight: 800, fontSize: 12, cursor: r.new_paid_full ? "pointer" : "not-allowed", fontFamily: "inherit", whiteSpace: "nowrap" }}>↩️ رفع طلب إرجاع</button>}</td>
            </tr>))}</tbody>
        </table>
      </div>}
      {modal && <ResaleRefundModal cycle={modal} onClose={() => setModal(null)} onSuccess={() => { load(); onRequested && onRequested(); }} />}
      {detail && <ResaleCycleDetailModal transferId={detail} canRequest={canRequest} onClose={() => setDetail(null)} onRequested={() => { load(); onRequested && onRequested(); }} />}{/* v3.4.376 */}
    </div>
  );
}

function NewRequestModal({ onClose, onSuccess }) {
  const [reservations, setReservations] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRes, setSelectedRes] = useState(null);
  const [requestType, setRequestType] = useState("");
  const [amount, setAmount] = useState("");
  const [resaleCycle, setResaleCycle] = useState(null); const [resaleModal, setResaleModal] = useState(false); // v3.4.373
  useEffect(() => { setResaleCycle(null); if (!selectedRes?.id) return; disbApi.resaleCycles({ reservation_id: selectedRes.id }).then(r => setResaleCycle((r.data?.rows || []).find(c => c.is_latest) || null)).catch(() => {}); }, [selectedRes?.id]); // v3.4.373 — هل هذا الحجز عميل سابق في دورة إعادة بيع؟
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const searchTimer = useRef(null);

  const searchReservations = useCallback(async (q) => {
    setLoading(true);
    try {
      const res = await disbApi.getReservations(q);
      setReservations(res.data.reservations || []);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    searchReservations("");
  }, [searchReservations]);

  const handleSearch = (q) => {
    setSearch(q);
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => searchReservations(q), 300);
  };

  const handleSelectRes = (res) => {
    setSelectedRes(res);
    setRequestType("");
    setAmount("");
  };

  const handleSelectType = (type) => {
    setRequestType(type);
    if (type === 'dalala') {
      setAmount(selectedRes?.dalala_amount || "");
    } else {
      setAmount(selectedRes?.deposit_amount || "");
    }
  };

  const handleSubmit = async () => {
    if (!selectedRes || !requestType || !amount) {
      toast.error("جميع الحقول مطلوبة");
      return;
    }
    setSubmitting(true);
    try {
      await disbApi.create({
        reservation_id: selectedRes.id,
        request_type: requestType,
        amount: Number(amount),
        notes
      });
      toast.success("تم رفع الطلب بنجاح");
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.error || "فشل في رفع الطلب");
    }
    setSubmitting(false);
  };

  return (
    <>
    {resaleModal && resaleCycle && <ResaleRefundModal cycle={resaleCycle} onClose={() => setResaleModal(false)} onSuccess={() => { onSuccess && onSuccess(); onClose && onClose(); }} />}{/* v3.4.373 */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 24,
          width: 600,
          maxWidth: "95vw",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 8px 30px rgba(0,0,0,0.15)"
        }}
        onClick={e => e.stopPropagation()}
        dir="rtl"
      >
        <h3 style={{ fontSize: 18, marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
          <FiPlus /> رفع طلب جديد
        </h3>

        {/* الخطوة 1: اختيار الحجز */}
        {!selectedRes ? (
          <>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>ابحث عن الحجز:</label>
              <input
                value={search}
                onChange={e => handleSearch(e.target.value)}
                placeholder="رقم الحجز أو اسم العميل أو المطور..."
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  fontSize: 14,
                  marginTop: 6
                }}
              />
            </div>
            <div style={{ maxHeight: 300, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 8 }}>
              {loading ? (
                <div style={{ padding: 20, textAlign: "center", color: "#94a3b8" }}>جاري البحث...</div>
              ) : reservations.length === 0 ? (
                <div style={{ padding: 20, textAlign: "center", color: "#94a3b8" }}>لا توجد حجوزات</div>
              ) : (
                reservations.map(res => (
                  <div
                    key={res.id}
                    onClick={() => handleSelectRes(res)}
                    style={{
                      padding: "12px 14px",
                      borderBottom: "1px solid #f1f5f9",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      transition: "background 0.1s"
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    <div>
                      <div style={{ fontWeight: 600 }}>#{res.id} - {res.client_name}</div>
                      <div style={{ fontSize: 12, color: "#64748b" }}>{res.developer} <span style={{ fontSize: 10, padding: "1px 6px", borderRadius: 8, marginRight: 4,
                        background: res.operation_status === "تمت العمليه" ? "#dcfce7" : "#fef3c7",
                        color: res.operation_status === "تمت العمليه" ? "#166534" : "#92400e",
                      }}>{res.operation_status || "—"}</span></div>
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontSize: 12 }}>دلالة: <strong>{fmt(res.dalala_amount)}</strong></div>
                      <div style={{ fontSize: 12 }}>عربون: <strong>{fmt(res.deposit_amount)}</strong></div>
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "flex-end", maxWidth: 180 }}>
                      {res.has_dalala_request && <span style={{ fontSize: 10, background: "#fef3c7", color: "#92400e", padding: "2px 6px", borderRadius: 8 }}>طلب دلالة موجود</span>}
                      {res.has_arboun_request && <span style={{ fontSize: 10, background: "#dbeafe", color: "#1e40af", padding: "2px 6px", borderRadius: 8 }}>طلب عربون موجود</span>}
                      {/* v3.3.619 — تنبيه بوجود طلب مؤرشف سابق على نفس الوحدة (لا يمنع رفع طلب جديد) */}
                      {res.has_archived_dalala_request && <span title="يوجد طلب دلالة مؤرشف سابق على هذه الوحدة" style={{ fontSize: 10, background: "#f1f5f9", color: "#64748b", border: "1px dashed #cbd5e1", padding: "2px 6px", borderRadius: 8 }}>دلالة مؤرشفة سابقاً 🗄️</span>}
                      {res.has_archived_arboun_request && <span title="يوجد طلب عربون مؤرشف سابق على هذه الوحدة" style={{ fontSize: 10, background: "#f1f5f9", color: "#64748b", border: "1px dashed #cbd5e1", padding: "2px 6px", borderRadius: 8 }}>عربون مؤرشف سابقاً 🗄️</span>}
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        ) : (
          <>
            {/* الخطوة 2: اختيار نوع الطلب */}
            <div style={{ background: "#f8fafc", padding: 14, borderRadius: 8, marginBottom: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontWeight: 600 }}>#{selectedRes.id} - {selectedRes.client_name}</div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>{selectedRes.developer}</div>
                </div>
                <button
                  onClick={() => setSelectedRes(null)}
                  style={{
                    padding: "4px 12px",
                    background: "#e2e8f0",
                    border: "none",
                    borderRadius: 6,
                    color: "#64748b",
                    cursor: "pointer",
                    fontSize: 12
                  }}
                >
                  تغيير
                </button>
              </div>
              {/* v3.3.619 — تنبيه بوجود طلب مؤرشف سابق على هذه الوحدة (يُسمح برفع طلب جديد) */}
              {(selectedRes.has_archived_dalala_request || selectedRes.has_archived_arboun_request) && (
                <div style={{ marginTop: 10, fontSize: 12, color: "#92400e", background: "#fffbeb", border: "1px dashed #fcd34d", borderRadius: 6, padding: "8px 10px" }}>
                  🗄️ يوجد طلب {[selectedRes.has_archived_dalala_request && "صرف دلالة", selectedRes.has_archived_arboun_request && "إرجاع عربون"].filter(Boolean).join(" و ")} مؤرشف سابق على هذه الوحدة. يمكنك رفع طلب جديد.
                </div>
              )}
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>نوع الطلب:</label>
              <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                {(() => {
                  const isOperationDone = selectedRes.operation_status === "تمت العمليه";
                  const isOperationNotDone = selectedRes.operation_status === "لم تتم العمليه";
                  const dalalaDisabled = selectedRes.has_dalala_request || !isOperationDone;
                  const dalalaBlockReason = selectedRes.has_dalala_request
                    ? "طلب موجود مسبقاً"
                    : !isOperationDone
                      ? "الدلالة تصرف فقط بعد إتمام العملية"
                      : "";
                  // Arboun is allowed when operation is done OR "لم تتم" (not during "بإنتظار إكمال")
                  const arbounAllowed = isOperationDone || isOperationNotDone;
                  const arbounDisabled = selectedRes.has_arboun_request || !arbounAllowed;
                  const arbounBlockReason = selectedRes.has_arboun_request
                    ? "طلب موجود مسبقاً"
                    : !arbounAllowed
                      ? "بإنتظار إكمال الإجراءات"
                      : "";

                  return (
                    <>
                      <button
                        onClick={() => !dalalaDisabled && handleSelectType('dalala')}
                        disabled={dalalaDisabled}
                        title={dalalaBlockReason}
                        style={{
                          flex: 1,
                          padding: "14px",
                          border: requestType === 'dalala' ? "2px solid #22c55e" : "1px solid #e2e8f0",
                          borderRadius: 8,
                          background: requestType === 'dalala' ? "#f0fdf4" : "#fff",
                          cursor: dalalaDisabled ? "not-allowed" : "pointer",
                          opacity: dalalaDisabled ? 0.5 : 1,
                          fontFamily: "inherit",
                        }}
                      >
                        <div style={{ fontSize: 16 }}>🟢</div>
                        <div style={{ fontWeight: 600, marginTop: 4 }}>صرف دلالة</div>
                        <div style={{ fontSize: 13, color: "#059669" }}>{fmt(selectedRes.dalala_amount)} ر.س</div>
                        {dalalaBlockReason && (
                          <div style={{ fontSize: 10, color: "#ef4444", marginTop: 4 }}>{dalalaBlockReason}</div>
                        )}
                      </button>
                      <button
                        onClick={() => !arbounDisabled && handleSelectType('arboun')}
                        disabled={arbounDisabled}
                        title={arbounBlockReason}
                        style={{
                          flex: 1,
                          padding: "14px",
                          border: requestType === 'arboun' ? "2px solid #3b82f6" : "1px solid #e2e8f0",
                          borderRadius: 8,
                          background: requestType === 'arboun' ? "#eff6ff" : "#fff",
                          cursor: arbounDisabled ? "not-allowed" : "pointer",
                          opacity: arbounDisabled ? 0.5 : 1,
                          fontFamily: "inherit",
                        }}
                      >
                        <div style={{ fontSize: 16 }}>🔵</div>
                        <div style={{ fontWeight: 600, marginTop: 4 }}>إرجاع عربون</div>
                        <div style={{ fontSize: 13, color: "#2563eb" }}>{fmt(selectedRes.deposit_amount)} ر.س</div>
                        {arbounBlockReason && (
                          <div style={{ fontSize: 10, color: "#ef4444", marginTop: 4 }}>{arbounBlockReason}</div>
                        )}
                      </button>
                      {/* v3.4.373 — إرجاع مبلغ إعادة بيع (يظهر عندما يكون الحجز عميلًا سابقًا في آخر دورة إعادة بيع للوحدة) */}
                      {resaleCycle && (
                        <button
                          onClick={() => setResaleModal(true)}
                          disabled={!!(resaleCycle.request && resaleCycle.request.status !== "مرفوض")}
                          title={resaleCycle.request && resaleCycle.request.status !== "مرفوض" ? `يوجد طلب: ${resaleCycle.request.status}` : ""}
                          style={{ flex: 1, padding: "14px", border: "1px solid #fed7aa", borderRadius: 8, background: "#fff7ed", cursor: "pointer", fontFamily: "inherit", opacity: resaleCycle.request && resaleCycle.request.status !== "مرفوض" ? 0.5 : 1 }}>
                          <div style={{ fontSize: 16 }}>↩️</div>
                          <div style={{ fontWeight: 600, marginTop: 4 }}>إرجاع مبلغ إعادة بيع</div>
                          <div style={{ fontSize: 13, color: "#b45309" }}>{fmt(resaleCycle.calc?.amount)} ر.س</div>
                          <div style={{ fontSize: 10, color: resaleCycle.new_paid_full ? "#166534" : "#ef4444", marginTop: 4 }}>{resaleCycle.new_paid_full ? "المشتري الجديد سدّد كاملًا ✓" : `المشتري الجديد سدّد ${resaleCycle.new_paid_pct}% — غير متاح بعد`}</div>
                        </button>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>

            {requestType && (
              <>
                {/* عرض تفاصيل الدلالة عند اختيار صرف دلالة */}
                {requestType === 'dalala' && (
                  <div style={{ 
                    marginBottom: 16, 
                    padding: 14, 
                    background: "#f0fdf4", 
                    borderRadius: 8,
                    border: "1px solid #bbf7d0"
                  }}>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center",
                      marginBottom: 12
                    }}>
                      <span style={{ fontSize: 13, fontWeight: 700, color: "#166534" }}>💎 تفاصيل توزيع الدلالة</span>
                      <button
                        onClick={() => window.open(`/?edit=${selectedRes.id}`, '_blank')}
                        style={{
                          padding: "4px 10px",
                          background: "#fff",
                          border: "1px solid #86efac",
                          borderRadius: 6,
                          color: "#166534",
                          cursor: "pointer",
                          fontSize: 11,
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          gap: 4
                        }}
                      >
                        ✏️ تعديل التوزيع
                      </button>
                    </div>
                    {/* v3.3.558 — Show new distribution structure (marketers + company split)
                        with computed percentages from amounts (legacy + new reservations) */}
                    {(() => {
                      const dalala = Number(selectedRes.dalala_amount) || 0;
                      const ext = Number(selectedRes.ext_marketer_share) || 0;
                      const intern = Number(selectedRes.int_marketer_share) || 0;
                      const m1 = Number(selectedRes.marketer1_share) || 0;
                      const m2 = Number(selectedRes.marketer2_share) || 0;
                      const dlk = Number(selectedRes.dalilak_share) || 0;
                      const waha = Number(selectedRes.waha_share) || 0;
                      const sm = Number(selectedRes.sales_mgr_share) || 0;
                      const mm = Number(selectedRes.mkt_mgr_share) || 0;
                      const co = Number(selectedRes.company_share) || 0;
                      const lm = selectedRes.linked_marketers || [];
                      const m1Name = lm[0]?.name || "المسوّق الداخلي 1";
                      const m2Name = lm[1]?.name || "المسوّق الداخلي 2";
                      const pctOf = (v) => dalala > 0 ? `${((v / dalala) * 100).toFixed(1)}%` : "0%";
                      const hasMarketersData = m1 > 0 || m2 > 0 || dlk > 0;
                      const cellStyle = { display: "flex", justifyContent: "space-between", padding: "6px 10px", background: "#fff", borderRadius: 6 };
                      const labelStyle = { fontSize: 11, color: "#64748b" };
                      const valStyle = { fontSize: 11, fontWeight: 600 };
                      return (
                        <>
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
                            <div style={cellStyle}>
                              <span style={labelStyle}>إجمالي الدلالة:</span>
                              <span style={{ ...valStyle, color: "#166534" }}>{fmt(dalala)} ر.س</span>
                            </div>
                            <div style={cellStyle}>
                              <span style={labelStyle}>المسوق:</span>
                              <span style={valStyle}>{selectedRes.marketer || lm.map(x => x.name).join("، ") || "—"}</span>
                            </div>
                            <div style={cellStyle}>
                              <span style={labelStyle}>خارجي ({pctOf(ext)}):</span>
                              <span style={valStyle}>{fmt(ext)} ر.س</span>
                            </div>
                            <div style={cellStyle}>
                              <span style={labelStyle}>داخلي ({pctOf(intern)}):</span>
                              <span style={valStyle}>{fmt(intern)} ر.س</span>
                            </div>
                          </div>

                          {/* Marketers block — only if any marketer/dalilak share */}
                          {hasMarketersData && (
                            <div style={{
                              background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                              border: "1px solid #93c5fd", borderRadius: 6, padding: 8, marginBottom: 8,
                            }}>
                              <div style={{ fontSize: 10, fontWeight: 700, color: "#1e40af", marginBottom: 6 }}>🎯 المسوقين والشركاء</div>
                              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                                <div style={cellStyle}><span style={labelStyle}>{m1Name} ({pctOf(m1)}):</span><span style={valStyle}>{fmt(m1)} ر.س</span></div>
                                <div style={cellStyle}><span style={labelStyle}>{m2Name} ({pctOf(m2)}):</span><span style={valStyle}>{fmt(m2)} ر.س</span></div>
                                <div style={cellStyle}><span style={labelStyle}>دليلك ({pctOf(dlk)}):</span><span style={valStyle}>{fmt(dlk)} ر.س</span></div>
                              </div>
                            </div>
                          )}

                          {/* Company block */}
                          <div style={{
                            background: "#f8fafc", border: "1px solid #cbd5e1", borderRadius: 6, padding: 8,
                          }}>
                            <div style={{ fontSize: 10, fontWeight: 700, color: "#475569", marginBottom: 6 }}>🏢 تقسيمة الشركة</div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                              <div style={cellStyle}><span style={labelStyle}>الإدارة ({pctOf(waha)}):</span><span style={valStyle}>{fmt(waha)} ر.س</span></div>
                              <div style={cellStyle}><span style={labelStyle}>م.مبيعات ({pctOf(sm)}):</span><span style={valStyle}>{fmt(sm)} ر.س</span></div>
                              <div style={cellStyle}><span style={labelStyle}>م.مسوقات ({pctOf(mm)}):</span><span style={valStyle}>{fmt(mm)} ر.س</span></div>
                              <div style={cellStyle}><span style={labelStyle}>الشركة ({pctOf(co)}):</span><span style={valStyle}>{fmt(co)} ر.س</span></div>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}

                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>المبلغ:</label>
                  <input
                    type="number"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "1px solid #e2e8f0",
                      borderRadius: 8,
                      fontSize: 14,
                      marginTop: 6
                    }}
                  />
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>ملاحظات (اختياري):</label>
                  <textarea
                    value={notes}
                    onChange={e => setNotes(e.target.value)}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "1px solid #e2e8f0",
                      borderRadius: 8,
                      fontSize: 14,
                      marginTop: 6,
                      resize: "vertical"
                    }}
                  />
                </div>
              </>
            )}
          </>
        )}

        {/* الأزرار */}
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          {selectedRes && requestType && (
            <button
              onClick={handleSubmit}
              disabled={submitting}
              style={{
                flex: 1,
                padding: "12px",
                background: "#166534",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: submitting ? "wait" : "pointer",
                opacity: submitting ? 0.7 : 1
              }}
            >
              {submitting ? "جاري الرفع..." : "رفع الطلب"}
            </button>
          )}
          <button
            onClick={onClose}
            style={{
              padding: "12px 24px",
              background: "#f1f5f9",
              color: "#64748b",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              fontSize: 14,
              cursor: "pointer"
            }}
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

// ══════════════════════════════════════════════════════════════
// نافذة تفاصيل الطلب
// ══════════════════════════════════════════════════════════════
const API_BASE = (typeof window !== "undefined" ? window.location.origin : ""); // v3.4.482 — نفس العنوان المفتوح (نطاق DO أو erp.rael.com.sa)

function RequestDetailModal({ request, onClose, onApprove, onExecute, onArchive, onUnarchive, canApprove, canExecute, isAdmin, showArchived, onSuccess }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [reservationDetails, setReservationDetails] = useState(null);
  const [unitDetails, setUnitDetails] = useState(null);
  const [unitPayments, setUnitPayments] = useState([]);
  const [scheduledPayments, setScheduledPayments] = useState([]);
  const [rejectNotes, setRejectNotes] = useState("");
  const [showRejectInput, setShowRejectInput] = useState(false);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        // جلب تفاصيل الحجز
        const resRes = await fetch(`${API_BASE}/api/reservations/${request.reservation_id}`, {
          credentials: "include"
        });
        if (resRes.ok) {
          const resData = await resRes.json();
          setReservationDetails(resData.reservation);

          // v3.3.375 — linked_unit_id يأتي من reservation_units أولاً ثم الـ legacy
          // v3.3.620 — مصدر موثوق للوحدة والمشروع: استخدم request.linked_unit (يُحسب في الباك
          // إند من reservation_units أو units.linked_reservation_id) كأولوية، لأن استعلام الصرف
          // لا يُرجع project_id على المستوى الأعلى وجدول الحجوزات يستخدم selected_project_id
          // (وليس project_id) — ما كان يجعل projectsApi.get(undefined) يفشل ويُظهر "لا توجد وحدة".
          let unitId = request.linked_unit?.unit_id || resData.reservation?.linked_unit_id;
          let projectId = request.linked_unit?.project_id
            || resData.reservation?.project_id
            || resData.reservation?.selected_project_id
            || request.project_id;

          // v3.3.386 — جلب الدفعات من كلا المصدرين دائماً (unit_payments + reservation_payments)
          // ثم نختار الأكثر شمولية (أكثر دفعات أو أكبر مجموع)
          let unitPaymentsList = [];
          let resPaymentsList = [];
          let scheduled = [];

          if (unitId) {
            try {
              // جلب تفاصيل الوحدة من المشروع
              let unit = null;
              if (projectId) {
                const projRes = await projectsApi.get(projectId);
                const allUnits = projRes.data.units || [];
                unit = allUnits.find(u => u.id === unitId);
              }
              // v3.3.620 — fallback: لو لم نعثر على الوحدة عبر المشروع (project_id مفقود أو
              // الوحدة غير ضمن قائمة المشروع)، نبني سجلاً مبدئياً من request.linked_unit حتى
              // يظهر الربط بدل رسالة "لا توجد وحدة".
              if (!unit && request.linked_unit?.unit_id) {
                unit = {
                  id: request.linked_unit.unit_id,
                  unit_label: request.linked_unit.unit_label,
                  project_id: request.linked_unit.project_id,
                  building_id: request.linked_unit.building_id,
                };
              }
              if (unit) setUnitDetails(unit);
              // الدفعات على مستوى الوحدة
              const paymentsRes = await fetch(`${API_BASE}/api/projects/units/${unitId}/payments`, { credentials: "include" });
              if (paymentsRes.ok) {
                const paymentsData = await paymentsRes.json();
                unitPaymentsList = paymentsData.payments || [];
                scheduled = paymentsData.scheduled_payments || [];
              }
            } catch (e) {
              console.error("Error fetching unit payments:", e);
            }
          }

          // الدفعات على مستوى الحجز (موجودة دائماً للحجوزات الخارجية)
          try {
            const resPayRes = await fetch(`${API_BASE}/api/reservations/${resData.reservation.id}/payments`, { credentials: "include" });
            if (resPayRes.ok) {
              const resPayData = await resPayRes.json();
              resPaymentsList = resPayData.payments || [];
            }
          } catch {}

          // v3.3.386 — اختر القائمة التي تحوي مجموعاً أكبر (الأكثر شمولاً)
          const sumU = unitPaymentsList.reduce((s, p) => s + Number(p.amount || 0), 0);
          const sumR = resPaymentsList.reduce((s, p) => s + Number(p.amount || 0), 0);
          const finalPayments = sumR > sumU ? resPaymentsList : (unitPaymentsList.length > 0 ? unitPaymentsList : resPaymentsList);
          setUnitPayments(finalPayments);
          setScheduledPayments(scheduled);
        }
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchDetails();
  }, [request.reservation_id, request.project_id]);

  const handleApprove = async () => {
    setProcessing(true);
    await onApprove(request.id, 'approved');
    setProcessing(false);
    onSuccess();
  };

  const handleReject = async () => {
    if (!rejectNotes.trim()) {
      alert("يرجى كتابة سبب الرفض");
      return;
    }
    setProcessing(true);
    await onApprove(request.id, 'rejected', rejectNotes);
    setProcessing(false);
    onSuccess();
  };

  const handleExecute = async () => {
    setProcessing(true);
    await onExecute(request.id);
    setProcessing(false);
    onSuccess();
  };

  const status = request.admin_status === 'rejected' ? 'rejected' :
                 request.accountant_status === 'done' ? 'done' :
                 request.admin_status === 'approved' ? 'pending_accountant' : 'pending_admin';

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          width: "100%",
          maxWidth: 900,
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 25px 50px rgba(0,0,0,0.25)"
        }}
      >
        {/* Header */}
        <div style={{
          background: request.request_type === 'dalala' ? "linear-gradient(135deg, #166534, #15803d)" : "linear-gradient(135deg, #1e40af, #2563eb)",
          color: "#fff",
          padding: "20px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20 }}>
              {TYPE_TITLE[request.request_type] || request.request_type}{/* v3.4.373 */}
            </h2>
            <div style={{ opacity: 0.8, marginTop: 4, fontSize: 13 }}>
              طلب #{request.id} - حجز #{request.reservation_id || request.serial_number}
            </div>
          </div>
          <span style={{
            background: "rgba(255,255,255,0.2)",
            padding: "6px 16px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600
          }}>
            {STATUS_LABELS[status]}
          </span>
        </div>

        {loading ? (
          <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>
            جاري تحميل التفاصيل...
          </div>
        ) : (
          <div style={{ padding: 24 }}>
            {/* معلومات الطلب */}
            <div style={groupStyle("#2563eb")}>{/* v3.4.716 — مجموعات حسب مصدر البيانات */}
              <GroupHead icon={<FiFileText />} title="معلومات الطلب" source="طلب الصرف" color="#2563eb" />
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
                <InfoCard label="المبلغ المطلوب" value={`${fmt(request.amount)} ر.س`} highlight />
                <InfoCard label="تاريخ الطلب" value={new Date(request.requested_at).toLocaleDateString("ar-SA")} />
                <InfoCard label="مقدم الطلب" value={request.requested_by_name} />
                {request.paid_externally && <InfoCard label="طريقة الصرف" value="💸 صُرفت خارج النظام سابقًا — اعتُمدت إداريًا تلقائيًا، وتحتاج تأكيد المحاسب فقط" />}{/* v3.4.217 */}
                {request.notes && <InfoCard label="ملاحظات" value={request.notes} full />}
              </div>
            </div>

            {/* معلومات الحجز - مع رابط */}
            {reservationDetails && (() => {
              // v3.3.548 — Use authoritative total_paid_amount from backend (which checks
              // unit_payments + reservation_payments + units.amount_received and picks max).
              // This avoids the bug in v3.3.547 where unitPayments came back empty for some
              // reservations and the summary showed paid=0 even though the unit had 300k paid.
              const totalPaidFromUnit = unitPayments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
              const backendTotalPaid = Number(reservationDetails.total_paid_amount) || 0;
              const totalPaid = Math.max(totalPaidFromUnit, backendTotalPaid);
              const depositAmount = Number(reservationDetails.deposit_amount) || 0;
              // If totalPaid already INCLUDES the deposit (via units.amount_received), don't double-add it.
              // We detect this heuristically: if backend total > local payments sum, the backend total is
              // already comprehensive — use it directly without adding deposit again.
              const fullPaid = backendTotalPaid > totalPaidFromUnit + depositAmount
                ? backendTotalPaid
                : totalPaid + depositAmount;
              // v3.4.715 — السعر الرسمي / الخصم المقدم / السعر التنفيذي من الحجز (كان «التنفيذي» = سعر الوحدة المعلن فظهر 320,000 بدل 250,000)
              const officialPrice = Number(reservationDetails.official_price) || Number(unitDetails?.price) || 0;
              const salePrice = Number(reservationDetails.value) || 0;
              const discountAmt = Number(reservationDetails.discount) || (officialPrice && salePrice && officialPrice > salePrice ? officialPrice - salePrice : 0);
              const unitPrice = salePrice || (officialPrice ? Math.max(0, officialPrice - discountAmt) : 0) || Number(unitDetails?.price) || 0; // السعر التنفيذي
              const remaining = unitPrice > 0 ? Math.max(0, unitPrice - fullPaid) : null;
              const paidPct = unitPrice > 0 ? Math.min(100, (fullPaid / unitPrice) * 100) : 0;
              const paymentsCount = Number(reservationDetails.payments_count) || unitPayments.length;
              return (
              <div style={groupStyle("#7c3aed")}>
                <GroupHead icon={<FiCalendar />} title="تفاصيل الحجز" source="سجل الحجوزات" color="#7c3aed" action="فتح الحجز"
                  onAction={() => { onClose(); navigate('/', { state: { openReservationId: reservationDetails.id } }); }} />{/* v3.3.361 — يفتح الحجز المحدد عبر state */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 }}>
                  <InfoCard label="رقم الحجز" value={`#${reservationDetails.id}`}
                    onClick={() => { onClose(); navigate('/', { state: { openReservationId: reservationDetails.id } }); }} />
                  <InfoCard label="المطور" value={reservationDetails.developer || request.developer} />
                  {/* v3.3.551 + v3.3.552 — Linked unit box, clickable → navigates to UnitFullPage.
                      Source priority:
                        1. unitDetails (fetched separately, most reliable with project_id)
                        2. request.linked_unit (from disbursements GET query)
                        3. reservationDetails.linked_unit_id (from /api/reservations/:id)
                  */}
                  {(() => {
                    let linkedUnit = null;
                    if (unitDetails?.id) {
                      linkedUnit = {
                        unit_id: unitDetails.id,
                        unit_label: unitDetails.unit_label,
                        project_id: unitDetails.project_id,
                        building_id: unitDetails.building_id,
                      };
                    } else if (request.linked_unit?.unit_id) {
                      linkedUnit = request.linked_unit;
                    } else if (reservationDetails.linked_unit_id) {
                      linkedUnit = {
                        unit_id: reservationDetails.linked_unit_id,
                        unit_label: null,
                        project_id: reservationDetails.project_id || null,
                        building_id: null,
                      };
                    }
                    if (!linkedUnit?.unit_id) {
                      return <InfoCard label="🏠 رمز الوحدة" value="غير مرتبطة" />;
                    }
                    const labelDisplay = linkedUnit.unit_label || `وحدة #${linkedUnit.unit_id}`;
                    return (
                      <InfoCard
                        label="🏠 رمز الوحدة"
                        value={labelDisplay}
                        highlight
                        onClick={() => {
                          onClose();
                          if (linkedUnit.project_id) {
                            // Open the dedicated full-page view for this unit
                            navigate(`/projects/${linkedUnit.project_id}/units/${linkedUnit.unit_id}`);
                          } else {
                            // Fallback: try to read project_id from reservationDetails
                            const pid = reservationDetails?.project_id;
                            if (pid) {
                              navigate(`/projects/${pid}/units/${linkedUnit.unit_id}`);
                            } else {
                              navigate('/projects');
                              toast("لا يمكن تحديد المشروع. افتح المشروع يدوياً.", { icon: "ℹ️" });
                            }
                          }
                        }}
                      />
                    );
                  })()}
                  <InfoCard label="نوع العملية" value={reservationDetails.operation_type} />
                  <InfoCard label="حالة العملية" value={reservationDetails.status} />
                  <InfoCard label="سعر البيع" value={reservationDetails.value ? `${fmt(reservationDetails.value)} ر.س` : "-"} />
                  <InfoCard label="العربون" value={depositAmount ? `${fmt(depositAmount)} ر.س` : "-"} />
                  <InfoCard label="قيمة الدلالة" value={reservationDetails.dalala_amount ? `${fmt(reservationDetails.dalala_amount)} ر.س` : "-"} />
                  <InfoCard label="تاريخ الحجز" value={reservationDetails.date ? new Date(reservationDetails.date).toLocaleDateString("ar-SA") : "-"} />
                </div>
                {/* v3.3.311: إجمالي المدفوع و المتبقي مع شريط تقدم */}
                {(unitPrice > 0 || fullPaid > 0) && (
                  <div style={{ marginTop: 14, padding: 14, background: "linear-gradient(135deg, #ecfeff, #f0f9ff)", border: "1px solid #67e8f9", borderRadius: 12 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#155e75", marginBottom: 10, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>💵 ملخص السداد للوحدة المرتبطة
                      <span style={{ fontSize: 10.5, fontWeight: 600, color: "#0e7490", background: "#cffafe", borderRadius: 999, padding: "1px 9px" }}>محسوب من دفعات الوحدة + بيانات الحجز</span>{/* v3.4.716 */}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10, marginBottom: 12 }}>
                      {/* v3.4.711 — ترتيب الصناديق بطلب المالك: العربون ← السعر التنفيذي ← المدفوع بدون العربون ← المتبقي — v3.4.715: + السعر الرسمي والخصم المقدم */}
                      <InfoCard label="العربون" value={depositAmount ? `${fmt(depositAmount)} ر.س` : "-"} />
                      <InfoCard label="السعر الرسمي" value={officialPrice ? `${fmt(officialPrice)} ر.س` : "-"} />
                      <InfoCard label="الخصم المقدم" value={discountAmt ? `${fmt(discountAmt)} ر.س` : "-"} />
                      <InfoCard label="السعر التنفيذي" value={unitPrice ? `${fmt(unitPrice)} ر.س` : "-"} />
                      <InfoCard label="المدفوع (بدون العربون)" value={`${fmt(totalPaid)} ر.س`} highlight />
                      <InfoCard label="المتبقي" value={remaining !== null ? `${fmt(remaining)} ر.س` : "-"} />
                    </div>
                    {unitPrice > 0 && (
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#155e75", marginBottom: 4 }}>
                          <span>نسبة السداد</span>
                          <span style={{ fontWeight: 700 }}>{paidPct.toFixed(1)}%</span>
                        </div>
                        <div style={{ height: 8, background: "#e0f2fe", borderRadius: 4, overflow: "hidden" }}>
                          <div style={{ height: "100%", width: `${paidPct}%`, background: paidPct >= 100 ? "linear-gradient(90deg, #10b981, #059669)" : "linear-gradient(90deg, #06b6d4, #0891b2)", transition: "width 0.3s" }}/>
                        </div>
                        <div style={{ fontSize: 10, color: "#64748b", marginTop: 6 }}>
                          العربون ({fmt(depositAmount)}) + الدفعات ({fmt(totalPaid)} من {paymentsCount} دفعة) = {fmt(fullPaid)} ر.س
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              );
            })()}

            {/* معلومات العميل */}
            {reservationDetails && (
              <div style={groupStyle("#0891b2")}>
                <GroupHead icon={<FiUser />} title="معلومات العميل" source="قواعد البيانات ← العملاء" color="#0891b2" />
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
                  <InfoCard label="اسم العميل" value={reservationDetails.linked_clients?.[0]?.name || reservationDetails.client_name || request.client_name}
                    onClick={() => {
                      const clientId = reservationDetails.linked_clients?.[0]?.id;
                      if (clientId) { onClose(); navigate(`/clients?id=${clientId}`); }
                    }} />
                  {/* v3.3.386 — رقم الجوال يُعرَض دائماً (من linked_clients أو من حقل reservation أو fallback) */}
                  <InfoCard label="رقم الجوال" value={reservationDetails.linked_clients?.[0]?.phone || reservationDetails.client_phone || "-"} />
                  {/* v3.3.386 — IBAN دائماً يُعرَض (highlight لو موجود) */}
                  <InfoCard label="الآيبان (IBAN)" value={reservationDetails.linked_clients?.[0]?.iban || "-"} highlight={!!reservationDetails.linked_clients?.[0]?.iban} />
                  {reservationDetails.linked_clients?.[0]?.client_number && (
                    <InfoCard label="رقم العميل" value={reservationDetails.linked_clients[0].client_number} />
                  )}
                  {reservationDetails.linked_clients?.[0]?.client_category && (
                    <InfoCard label="فئة العميل" value={reservationDetails.linked_clients[0].client_category} />
                  )}
                  {reservationDetails.linked_clients?.[0]?.classification && (
                    <InfoCard label="التصنيف" value={reservationDetails.linked_clients[0].classification} />
                  )}
                </div>
              </div>
            )}

            {/* توزيع الدلالة - كامل — v3.3.558: عرض النسب + المسوقين 1,2,دليلك بنفس بنية صفحة الحجوزات */}
            {request.request_type === 'dalala' && reservationDetails && (() => {
              const dalala = Number(reservationDetails.dalala_amount) || 0;
              const ext = Number(reservationDetails.ext_marketer_share) || 0;
              const intern = Number(reservationDetails.int_marketer_share) || 0;
              const m1 = Number(reservationDetails.marketer1_share) || 0;
              const m2 = Number(reservationDetails.marketer2_share) || 0;
              const dlk = Number(reservationDetails.dalilak_share) || 0;
              const waha = Number(reservationDetails.waha_share) || 0;
              const sm = Number(reservationDetails.sales_mgr_share) || 0;
              const mm = Number(reservationDetails.mkt_mgr_share) || 0;
              const co = Number(reservationDetails.company_share) || 0;
              // Pull marketer names from junction (linked_marketers) — same source as in App.js
              const lm = reservationDetails.linked_marketers || [];
              const m1Name = lm[0]?.name || "المسوّق الداخلي 1";
              const m2Name = lm[1]?.name || "المسوّق الداخلي 2";
              // Percentage of total dalala
              const pctOf = (v) => dalala > 0 ? ((v / dalala) * 100).toFixed(1) : "0";
              // Total for validation
              const marketersTotal = m1 + m2 + dlk;
              const companyTotal = waha + sm + mm + co;
              const grandTotal = ext + marketersTotal + companyTotal;
              const hasMarketersData = m1 > 0 || m2 > 0 || dlk > 0;
              return (
              <div style={groupStyle("#d97706")}>
                <GroupHead icon={<span>💎</span>} title="توزيع الدلالة" source="الحجز (نسب التوزيع)" color="#d97706" />

                {/* Top: total + external/internal split */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12, marginBottom: 12 }}>
                  <InfoCard label="إجمالي الدلالة" value={dalala ? `${fmt(dalala)} ر.س` : "-"} highlight />
                  <InfoCard label={`المسوق الخارجي (${pctOf(ext)}%)`} value={ext ? `${fmt(ext)} ر.س` : "-"} />
                  <InfoCard label={`الداخلي (${pctOf(intern)}%)`} value={intern ? `${fmt(intern)} ر.س` : "-"} />
                </div>

                {/* Marketers block — only shown if any marketer data exists (for new-format reservations) */}
                {hasMarketersData && (
                  <div style={{
                    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                    border: "2px solid #93c5fd",
                    borderRadius: 8, padding: 12, marginBottom: 12,
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#1e40af", marginBottom: 8 }}>
                      🎯 المسوقين والشركاء
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
                      <InfoCard label={`${m1Name} (${pctOf(m1)}%)`} value={m1 ? `${fmt(m1)} ر.س` : "-"} />
                      <InfoCard label={`${m2Name} (${pctOf(m2)}%)`} value={m2 ? `${fmt(m2)} ر.س` : "-"} />
                      <InfoCard label={`دليلك (${pctOf(dlk)}%)`} value={dlk ? `${fmt(dlk)} ر.س` : "-"} />
                    </div>
                    <div style={{ marginTop: 8, fontSize: 11, color: "#1e40af", fontWeight: 600 }}>
                      مجموع المسوقين: {fmt(marketersTotal)} ر.س ({pctOf(marketersTotal)}%)
                    </div>
                  </div>
                )}

                {/* Company block */}
                <div style={{
                  background: "#f8fafc",
                  border: "1px solid #cbd5e1",
                  borderRadius: 8, padding: 12,
                }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#475569", marginBottom: 8 }}>
                    🏢 تقسيمة الشركة (إجمالي: {fmt(companyTotal)} ر.س)
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
                    <InfoCard label={`الإدارة (${pctOf(waha)}%)`} value={waha ? `${fmt(waha)} ر.س` : "-"} />
                    <InfoCard label={`مدير المبيعات (${pctOf(sm)}%)`} value={sm ? `${fmt(sm)} ر.س` : "-"} />
                    <InfoCard label={`مديرة المسوقات (${pctOf(mm)}%)`} value={mm ? `${fmt(mm)} ر.س` : "-"} />
                    <InfoCard label={`الشركة (${pctOf(co)}%)`} value={co ? `${fmt(co)} ر.س` : "-"} />
                  </div>
                </div>

                {/* Validation warning if totals don't add up */}
                {dalala > 0 && Math.abs(grandTotal - dalala) > 1 && (
                  <div style={{ marginTop: 10, padding: "8px 12px", background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 8, fontSize: 12, color: "#92400e" }}>
                    ⚠️ مجموع التوزيع ({fmt(grandTotal)} ر.س) لا يطابق إجمالي الدلالة ({fmt(dalala)} ر.س) — فرق: {fmt(dalala - grandTotal)} ر.س
                  </div>
                )}
              </div>
              );
            })()}

            {/* v3.3.311: بيانات المسوق الكاملة */}
            {reservationDetails?.linked_marketers?.length > 0 && (
              <div style={groupStyle("#db2777")}>
                <GroupHead icon={<span>📣</span>} title="بيانات المسوق" source="قواعد البيانات ← المسوّقون" color="#db2777" />
                {reservationDetails.linked_marketers.map((m, idx) => (
                  <div key={m.id || idx} style={{ marginBottom: 12, padding: 12, background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0" }}>
                    <div
                      onClick={() => { if (m.id) { onClose(); navigate(`/marketers?id=${m.id}`); } }}
                      style={{ fontSize: 13, fontWeight: 700, color: m.id ? "#2563eb" : "#1e3a5f", marginBottom: 10, cursor: m.id ? "pointer" : "default", textDecoration: m.id ? "underline dotted" : "none", textUnderlineOffset: 3 }}
                      title={m.id ? "اضغط لفتح صفحة المسوق" : ""}>
                      👤 {m.name || "—"} {m.id && <span style={{ fontSize: 10, color: "#94a3b8", marginInlineStart: 4 }}>↗</span>}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
                      <InfoCard label="رقم الجوال" value={m.phone || "-"} />
                      <InfoCard label="الآيبان (IBAN)" value={m.iban || "-"} highlight={!!m.iban} />
                      <InfoCard label="اسم البنك" value={m.bank_name || "-"} />
                      <InfoCard label="رقم الهوية" value={m.id_number || "-"} />
                      <InfoCard label="الجنسية" value={m.nationality || "-"} />
                      <InfoCard label="التصنيف" value={m.classification || "-"} />
                      {m.office && <InfoCard label="المكتب/الشركة" value={m.office} />}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* معلومات الوحدة المرتبطة - كاملة */}
            {unitDetails ? (
              <div style={groupStyle("#16a34a")}>
                <GroupHead icon={<FiHome />} title="معلومات الوحدة المرتبطة" source="مشاريع الشركة" color="#16a34a" action="فتح في صفحة المشاريع"
                  onAction={() => { onClose(); navigate(`/projects?id=${unitDetails.project_id}`); }} />{/* v3.3.361 */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12 }}>
                  <InfoCard label="رقم الوحدة" value={unitDetails.unit_label || `#${unitDetails.id}`}
                    onClick={() => { onClose(); navigate(`/projects/${unitDetails.project_id}/units/${unitDetails.id}`); }} />
                  <InfoCard label="نوع الوحدة" value={unitDetails.unit_type} />
                  <InfoCard label="الدور" value={unitDetails.floor_number} />
                  <InfoCard label="المساحة" value={unitDetails.area_sqm ? `${unitDetails.area_sqm} م²` : "-"} />
                  <InfoCard label="الواجهة" value={unitDetails.facade || "-"} />
                  <InfoCard label="عدد الغرف" value={unitDetails.rooms || "-"} />
                  <InfoCard label="السعر الرسمي" value={unitDetails.price ? `${fmt(unitDetails.price)} ر.س` : "-"} highlight />
                  <InfoCard label="حالة الوحدة" value={unitDetails.status === 'reserved' ? 'محجوزة' : unitDetails.status === 'sold' ? 'مباعة' : unitDetails.status} />
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: 16, background: "#f8fafc", border: "1px dashed #cbd5e1", borderRadius: 14, padding: 16, textAlign: "center", color: "#64748b", fontSize: 12 }}>{/* v3.4.716 */}
                <FiHome size={20} style={{ margin: "0 auto 6px", display: "block", color: "#94a3b8" }} />
                لا توجد وحدة مرتبطة من مشاريع الشركة بهذا الحجز
              </div>
            )}

            {/* جدول الدفعات المسددة */}
            {unitPayments.length > 0 && (
              <div style={groupStyle("#0f766e")}>
                <GroupHead icon={<span>💵</span>} title={`الدفعات المسددة (${unitPayments.length})`} source="دفعات الوحدة ← مشاريع الشركة" color="#0f766e" />
                <div style={{ background: "#f8fafc", borderRadius: 12, overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: "#e2e8f0" }}>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>#</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>التاريخ</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>المبلغ</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>طريقة الدفع</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>ملاحظات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {unitPayments.map((p, i) => (
                        <tr key={p.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                          <td style={{ padding: "10px 12px" }}>{i + 1}</td>
                          <td style={{ padding: "10px 12px" }}>{p.payment_date ? new Date(p.payment_date).toLocaleDateString("ar-SA") : "-"}</td>
                          <td style={{ padding: "10px 12px", fontWeight: 600, color: "#166534" }}>{fmt(p.amount)} ر.س</td>
                          <td style={{ padding: "10px 12px" }}>{p.payment_method || "-"}</td>
                          <td style={{ padding: "10px 12px", color: "#64748b" }}>{p.notes || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ background: "#dcfce7" }}>
                        <td colSpan={2} style={{ padding: "10px 12px", fontWeight: 700 }}>الإجمالي</td>
                        <td colSpan={3} style={{ padding: "10px 12px", fontWeight: 700, color: "#166534" }}>
                          {fmt(unitPayments.reduce((sum, p) => sum + Number(p.amount || 0), 0))} ر.س
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}

            {/* جدول الدفعات المجدولة */}
            {scheduledPayments.length > 0 && (
              <div style={groupStyle("#0369a1")}>
                <GroupHead icon={<span>📅</span>} title={`الدفعات المجدولة (${scheduledPayments.length})`} source="جدول دفعات الوحدة ← مشاريع الشركة" color="#0369a1" />
                <div style={{ background: "#f8fafc", borderRadius: 12, overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: "#e2e8f0" }}>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>#</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>تاريخ الاستحقاق</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>المبلغ</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>الوصف</th>
                        <th style={{ padding: "10px 12px", textAlign: "right" }}>الحالة</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scheduledPayments.map((p, i) => (
                        <tr key={p.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                          <td style={{ padding: "10px 12px" }}>{i + 1}</td>
                          <td style={{ padding: "10px 12px" }}>{p.due_date ? new Date(p.due_date).toLocaleDateString("ar-SA") : "-"}</td>
                          <td style={{ padding: "10px 12px", fontWeight: 600 }}>{fmt(p.amount)} ر.س</td>
                          <td style={{ padding: "10px 12px" }}>{p.description || "-"}</td>
                          <td style={{ padding: "10px 12px" }}>
                            <span style={{
                              background: p.status === 'paid' ? "#dcfce7" : p.status === 'overdue' ? "#fee2e2" : "#fef3c7",
                              color: p.status === 'paid' ? "#166534" : p.status === 'overdue' ? "#991b1b" : "#92400e",
                              padding: "2px 8px",
                              borderRadius: 10,
                              fontSize: 11,
                              fontWeight: 600
                            }}>
                              {p.status === 'paid' ? 'مدفوع' : p.status === 'overdue' ? 'متأخر' : 'معلق'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ background: "#dbeafe" }}>
                        <td colSpan={2} style={{ padding: "10px 12px", fontWeight: 700 }}>الإجمالي</td>
                        <td colSpan={3} style={{ padding: "10px 12px", fontWeight: 700, color: "#1e40af" }}>
                          {fmt(scheduledPayments.reduce((sum, p) => sum + Number(p.amount || 0), 0))} ر.س
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}

            {/* سجل الاعتمادات */}
            <div style={groupStyle("#64748b")}>
              <GroupHead icon={<span>📋</span>} title="سجل الاعتمادات" source="هذا الطلب" color="#64748b" />
              <div style={{ background: "#f8fafc", borderRadius: 12, padding: 16 }}>
                <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>اعتماد المدير</div>
                    {request.admin_status === 'pending' ? (
                      <span style={{ color: "#f59e0b" }}>⏳ بانتظار الاعتماد</span>
                    ) : request.admin_status === 'approved' ? (
                      <div>
                        <span style={{ color: "#22c55e" }}>✅ معتمد</span>
                        <div style={{ fontSize: 11, color: "#64748b" }}>بواسطة: {request.admin_by_name}</div>
                        {request.admin_at && <div style={{ fontSize: 11, color: "#64748b" }}>{new Date(request.admin_at).toLocaleDateString("ar-SA")}</div>}
                      </div>
                    ) : (
                      <div>
                        <span style={{ color: "#ef4444" }}>❌ مرفوض</span>
                        <div style={{ fontSize: 11, color: "#64748b" }}>بواسطة: {request.admin_by_name}</div>
                        {request.admin_notes && <div style={{ fontSize: 11, color: "#ef4444" }}>السبب: {request.admin_notes}</div>}
                      </div>
                    )}
                  </div>
                  <div>
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>تنفيذ المحاسب</div>
                    {request.admin_status !== 'approved' ? (
                      <span style={{ color: "#94a3b8" }}>—</span>
                    ) : request.accountant_status === 'pending' ? (
                      <span style={{ color: "#3b82f6" }}>⏳ بانتظار التنفيذ</span>
                    ) : (
                      <div>
                        <span style={{ color: "#22c55e" }}>✅ تم التنفيذ</span>
                        <div style={{ fontSize: 11, color: "#64748b" }}>بواسطة: {request.accountant_by_name}</div>
                        {request.accountant_at && <div style={{ fontSize: 11, color: "#64748b" }}>{new Date(request.accountant_at).toLocaleDateString("ar-SA")}</div>}
                        <div style={{ fontSize: 11.5, color: "#0f172a", marginTop: 4 }}>📅 تاريخ الصرف: <b>{paidDateOf(request) || "—"}</b> · طريقة الصرف: <b>{payMethodLabel(request.payment_method)}</b></div>{/* v3.4.372 */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* حقل سبب الرفض */}
            {showRejectInput && (
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", marginBottom: 8, fontWeight: 600, color: "#dc2626" }}>سبب الرفض *</label>
                <textarea
                  value={rejectNotes}
                  onChange={e => setRejectNotes(e.target.value)}
                  placeholder="اكتب سبب الرفض..."
                  style={{
                    width: "100%",
                    padding: 12,
                    border: "2px solid #fca5a5",
                    borderRadius: 8,
                    fontSize: 14,
                    minHeight: 80,
                    resize: "vertical"
                  }}
                />
              </div>
            )}
          </div>
        )}

        {/* Footer Actions */}
        <div style={{
          padding: "16px 24px",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          gap: 12,
          justifyContent: "flex-end",
          flexWrap: "wrap",
          background: "#f8fafc"
        }}>
          {/* أزرار الاعتماد للمدير */}
          {canApprove && request.admin_status === 'pending' && !showRejectInput && (
            <>
              <button
                onClick={handleApprove}
                disabled={processing}
                style={{
                  padding: "12px 24px",
                  background: "#22c55e",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: processing ? "wait" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 8
                }}
              >
                <FiCheck size={18} /> اعتماد الطلب
              </button>
              <button
                onClick={() => setShowRejectInput(true)}
                style={{
                  padding: "12px 24px",
                  background: "#ef4444",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 8
                }}
              >
                <FiX size={18} /> رفض الطلب
              </button>
            </>
          )}

          {/* تأكيد الرفض */}
          {showRejectInput && (
            <>
              <button
                onClick={handleReject}
                disabled={processing}
                style={{
                  padding: "12px 24px",
                  background: "#dc2626",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: processing ? "wait" : "pointer"
                }}
              >
                تأكيد الرفض
              </button>
              <button
                onClick={() => { setShowRejectInput(false); setRejectNotes(""); }}
                style={{
                  padding: "12px 24px",
                  background: "#f1f5f9",
                  color: "#64748b",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  cursor: "pointer"
                }}
              >
                إلغاء
              </button>
            </>
          )}

          {/* v3.4.373 — تفصيل حساب إرجاع مبلغ إعادة البيع */}
          {request.request_type === 'resale_refund' && request.calc && (
            <div style={{ margin: "12px 0", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 10, padding: "10px 14px", fontSize: 13 }}>
              <div style={{ fontWeight: 900, color: "#9a3412", marginBottom: 6 }}>↩️ حساب مبلغ الإرجاع ({request.calc.kind === 2 ? "إعادة بيع - 2" : "إعادة بيع - 1"}){request.calc.edited ? " — معدّل يدويًا" : " — محسوب تلقائيًا"}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "4px 16px" }}>
                <span>{request.calc.base_label}</span><b style={{ fontFamily: "monospace" }}>{fmtN0(request.calc.base)}</b>
                <span>− {request.calc.d1_label}</span><b style={{ fontFamily: "monospace" }}>{fmtN0(request.calc.d1)}</b>
                <span>− {request.calc.d2_label}</span><b style={{ fontFamily: "monospace" }}>{fmtN0(request.calc.d2)}</b>
                <span style={{ fontWeight: 900 }}>= مبلغ الإرجاع</span><b style={{ fontFamily: "monospace", color: "#0f766e" }}>{fmtN0(request.amount)} ر.س</b>
              </div>
            </div>
          )}
          {/* زر التنفيذ للمحاسب */}
          {canExecute && request.admin_status === 'approved' && request.accountant_status === 'pending' && (
            <button
              onClick={handleExecute}
              disabled={processing}
              style={{
                padding: "12px 24px",
                background: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: processing ? "wait" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8
              }}
            >
              <FiDollarSign size={18} /> تنفيذ الصرف
            </button>
          )}

          {/* زر الأرشفة */}
          {isAdmin && status !== 'pending_admin' && !showArchived && (
            <button
              onClick={() => onArchive(request.id)}
              style={{
                padding: "12px 24px",
                background: "#f8fafc",
                color: "#64748b",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                fontSize: 14,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8
              }}
            >
              📦 أرشفة الطلب
            </button>
          )}

          {/* زر إلغاء الأرشفة */}
          {isAdmin && showArchived && (
            <button
              onClick={() => onUnarchive(request.id)}
              style={{
                padding: "12px 24px",
                background: "#ecfdf5",
                color: "#059669",
                border: "1px solid #a7f3d0",
                borderRadius: 8,
                fontSize: 14,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8
              }}
            >
              ↩️ إلغاء الأرشفة
            </button>
          )}

          {/* زر الإغلاق */}
          {!showRejectInput && (
            <button
              onClick={onClose}
              style={{
                padding: "12px 24px",
                background: "#f1f5f9",
                color: "#64748b",
                border: "none",
                borderRadius: 8,
                fontSize: 14,
                cursor: "pointer"
              }}
            >
              إغلاق
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// v3.4.716 — مجموعات حسب مصدر البيانات (بطلب المالك): إطار بلون المصدر + رأس يسمّي المصدر وزر لفتحه
const groupStyle = (color) => ({ marginBottom: 16, background: "#fff", border: `1px solid ${color}33`, borderInlineStart: `5px solid ${color}`, borderRadius: 14, padding: "14px 16px 16px", boxShadow: "0 1px 3px rgba(15,23,42,.06)" });
function GroupHead({ icon, title, source, color, action, onAction }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
      <span style={{ width: 30, height: 30, borderRadius: 9, background: color + "1a", color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 15, flex: "none" }}>{icon}</span>
      <div style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>{title}</div>
      <span title="من أين تأتي بيانات هذه المجموعة" style={{ fontSize: 10.5, fontWeight: 700, color, background: color + "14", border: `1px solid ${color}44`, borderRadius: 999, padding: "2px 10px" }}>المصدر: {source}</span>
      {action && (
        <button type="button" onClick={onAction} style={{ marginInlineStart: "auto", fontSize: 12, color, background: "none", border: `1px solid ${color}55`, borderRadius: 8, padding: "4px 10px", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 5, fontFamily: "inherit", fontWeight: 600 }}>
          <FiExternalLink size={13} /> {action}
        </button>
      )}
    </div>
  );
}
// مكون بطاقة المعلومات
function InfoCard({ label, value, highlight, full, onClick, color }) {
  const clickable = !!onClick && value && value !== "-";
  return (
    <div onClick={clickable ? onClick : undefined} style={{
      background: highlight ? "#f0fdf4" : "#f8fafc",
      border: highlight ? "1px solid #86efac" : "1px solid #e2e8f0",
      borderRadius: 10,
      padding: "12px 16px",
      gridColumn: full ? "1 / -1" : "auto",
      cursor: clickable ? "pointer" : "default",
      transition: "all 0.15s",
    }}
    onMouseEnter={clickable ? e => { e.currentTarget.style.background = "#eff6ff"; e.currentTarget.style.borderColor = "#93c5fd"; } : undefined}
    onMouseLeave={clickable ? e => { e.currentTarget.style.background = highlight ? "#f0fdf4" : "#f8fafc"; e.currentTarget.style.borderColor = highlight ? "#86efac" : "#e2e8f0"; } : undefined}
    >
      <div style={{ fontSize: 11, color: "#64748b", marginBottom: 4 }}>{label}{clickable && <span style={{ marginInlineStart: 4, color: "#2563eb" }}>↗</span>}</div>
      <div style={{ fontSize: highlight ? 18 : 14, fontWeight: highlight ? 700 : 500, color: color || (highlight ? "#166534" : (clickable ? "#2563eb" : "#1e293b")), textDecoration: clickable ? "underline dotted" : "none", textUnderlineOffset: 3 }}>
        {value || "-"}
      </div>
    </div>
  );
}
